export const ODDS_DATA = {
  draw: { en: "draw", pt: "empate", es: "empate" },
  "{$competitor1} regular time": {
    en: "{$competitor1} regular time",
    pt: "{$competitor1} tempo regular",
    es: "{$competitor1} tiempo regular"
  },
  "{$competitor2} regular time": {
    en: "{$competitor2} regular time",
    pt: "{$competitor2} tempo regular",
    es: "{$competitor2} tiempo regular"
  },
  "{$competitor1} overtime": {
    en: "{$competitor1} overtime",
    pt: "{$competitor1} prolongamento",
    es: "{$competitor1} prórroga"
  },
  "{$competitor2} overtime": {
    en: "{$competitor2} overtime",
    pt: "{$competitor2} prolongamento",
    es: "{$competitor2} prórroga"
  },
  "{$competitor1} penalties": {
    en: "{$competitor1} penalties",
    pt: "{$competitor1} penalidade",
    es: "{$competitor1} penales"
  },
  "{$competitor2} penalties": {
    en: "{$competitor2} penalties",
    pt: "{$competitor2} penalidade",
    es: "{$competitor2} penales"
  },
  none: { en: "none", pt: "nenhum", es: "ninguno" },
  "{$competitor1} or draw": {
    en: "{$competitor1} or draw",
    pt: "{$competitor1} ou empate",
    es: "{$competitor1} o empate"
  },
  "{$competitor1} or {$competitor2}": {
    en: "{$competitor1} or {$competitor2}",
    pt: "{$competitor1} ou {$competitor2}",
    es: "{$competitor1} o {$competitor2}"
  },
  "draw or {$competitor2}": {
    en: "draw or {$competitor2}",
    pt: "empate ou {$competitor2}",
    es: "empate o {$competitor2}"
  },
  "{$competitor1} ({hcp})": {
    en: "{$competitor1} ({hcp})",
    pt: "{$competitor1} ({hcp})",
    es: "{$competitor1} ({hcp})"
  },
  "draw ({hcp})": {
    en: "draw ({hcp})",
    pt: "empate ({hcp})",
    es: "empate ({hcp})"
  },
  "{$competitor2} ({hcp})": {
    en: "{$competitor2} ({hcp})",
    pt: "{$competitor2} ({hcp})",
    es: "{$competitor2} ({hcp})"
  },
  "{$competitor1} by 1": {
    en: "{$competitor1} by 1",
    pt: "{$competitor1} by 1",
    es: "{$competitor1} por 1"
  },
  "{$competitor1} by 2": {
    en: "{$competitor1} by 2",
    pt: "{$competitor1} by 2",
    es: "{$competitor1} por 2"
  },
  "{$competitor1} by 3+": {
    en: "{$competitor1} by 3+",
    pt: "{$competitor1} by 3+",
    es: "{$competitor1} por 3+"
  },
  "{$competitor2} by 1": {
    en: "{$competitor2} by 1",
    pt: "{$competitor2} by 1",
    es: "{$competitor2} por 1"
  },
  "{$competitor2} by 2": {
    en: "{$competitor2} by 2",
    pt: "{$competitor2} by 2",
    es: "{$competitor2} por 2"
  },
  "{$competitor2} by 3+": {
    en: "{$competitor2} by 3+",
    pt: "{$competitor2} by 3+",
    es: "{$competitor2} por 3+"
  },
  "{$competitor1} by 11+": {
    en: "{$competitor1} by 11+",
    pt: "{$competitor1} by 11+",
    es: "{$competitor1} por 11+"
  },
  "{$competitor1} by 6-10": {
    en: "{$competitor1} by 6-10",
    pt: "{$competitor1} by 6-10",
    es: "{$competitor1} por 6-10"
  },
  "{$competitor1} by 1-5": {
    en: "{$competitor1} by 1-5",
    pt: "{$competitor1} by 1-5",
    es: "{$competitor1} por 1-5"
  },
  "{$competitor2} by 1-5": {
    en: "{$competitor2} by 1-5",
    pt: "{$competitor2} by 1-5",
    es: "{$competitor2} por 1-5"
  },
  "{$competitor2} by 6-10": {
    en: "{$competitor2} by 6-10",
    pt: "{$competitor2} by 6-10",
    es: "{$competitor2} por 6-10"
  },
  "{$competitor2} by 11+": {
    en: "{$competitor2} by 11+",
    pt: "{$competitor2} by 11+",
    es: "{$competitor2} por 11+"
  },
  "{$competitor1} by 15+": {
    en: "{$competitor1} by 15+",
    pt: "{$competitor1} by 15+",
    es: "{$competitor1} por 15+"
  },
  "{$competitor1} by 8-14": {
    en: "{$competitor1} by 8-14",
    pt: "{$competitor1} by 8-14",
    es: "{$competitor1} por 8-14"
  },
  "{$competitor1} by 1-7": {
    en: "{$competitor1} by 1-7",
    pt: "{$competitor1} by 1-7",
    es: "{$competitor1} por 1-7"
  },
  "{$competitor2} by 1-7": {
    en: "{$competitor2} by 1-7",
    pt: "{$competitor2} by 1-7",
    es: "{$competitor2} por 1-7"
  },
  "{$competitor2} by 8-14": {
    en: "{$competitor2} by 8-14",
    pt: "{$competitor2} by 8-14",
    es: "{$competitor2} por 8-14"
  },
  "{$competitor2} by 15+": {
    en: "{$competitor2} by 15+",
    pt: "{$competitor2} by 15+",
    es: "{$competitor2} por 15+"
  },
  "{$competitor1} ({+hcp})": {
    en: "{$competitor1} ({+hcp})",
    pt: "{$competitor1} ({+hcp})",
    es: "{$competitor1} ({+hcp})"
  },
  "{$competitor2} ({-hcp})": {
    en: "{$competitor2} ({-hcp})",
    pt: "{$competitor2} ({-hcp})",
    es: "{$competitor2} ({-hcp})"
  },
  "over {total}": {
    en: "over {total}",
    pt: "mais de {total}",
    es: "más de {total}"
  },
  "under {total}": {
    en: "under {total}",
    pt: "menos de {total}",
    es: "menos de {total}"
  },
  odd: { en: "odd", pt: "impar", es: "impar" },
  even: { en: "even", pt: "par", es: "par" },
  yes: { en: "yes", pt: "sim", es: "sí" },
  no: { en: "no", pt: "não", es: "no" },
  "only {$competitor1}": {
    en: "only {$competitor1}",
    pt: "apenas {$competitor1}",
    es: "solo {$competitor1}"
  },
  "only {$competitor2}": {
    en: "only {$competitor2}",
    pt: "apenas {$competitor2}",
    es: "solo {$competitor2}"
  },
  "both teams": {
    en: "both teams",
    pt: "ambas as equipas",
    es: "ambos equipos"
  },
  "{$competitor1} &amp; yes": {
    en: "{$competitor1} &amp; yes",
    pt: "{$competitor1} e sim",
    es: "{$competitor1} y sí"
  },
  "{$competitor1} &amp; no": {
    en: "{$competitor1} &amp; no",
    pt: "{$competitor1} e não",
    es: "{$competitor1} y no"
  },
  "draw &amp; yes": {
    en: "draw &amp; yes",
    pt: "empate e sim",
    es: "empate y sí"
  },
  "draw &amp; no": {
    en: "draw &amp; no",
    pt: "empate e não",
    es: "empate y no"
  },
  "{$competitor2} &amp; yes": {
    en: "{$competitor2} &amp; yes",
    pt: "{$competitor2} e sim",
    es: "{$competitor2} y sí"
  },
  "{$competitor2} &amp; no": {
    en: "{$competitor2} &amp; no",
    pt: "{$competitor2} e não",
    es: "{$competitor2} y no"
  },
  "over {total} &amp; yes": {
    en: "over {total} &amp; yes",
    pt: "mais de {total} e sim",
    es: "más de {total} y sí"
  },
  "under {total} &amp; yes": {
    en: "under {total} &amp; yes",
    pt: "menos de {total} e sim",
    es: "menos de {total} y sí"
  },
  "over {total} &amp; no": {
    en: "over {total} &amp; no",
    pt: "mais de {total} e não",
    es: "más de {total} y no"
  },
  "under {total} &amp; no": {
    en: "under {total} &amp; no",
    pt: "menos de {total} e não",
    es: "menos de {total} y no"
  },
  "{$competitor1} &amp; under {total}": {
    en: "{$competitor1} &amp; under {total}",
    pt: "{$competitor1} e menos de {total}",
    es: "{$competitor1} y menos de {total}"
  },
  "{$competitor1} &amp; over {total}": {
    en: "{$competitor1} &amp; over {total}",
    pt: "{$competitor1} e mais de {total}",
    es: "{$competitor1} y más de {total}"
  },
  "draw &amp; under {total}": {
    en: "draw &amp; under {total}",
    pt: "empate e menos de {total}",
    es: "empate y menos de {total}"
  },
  "draw &amp; over {total}": {
    en: "draw &amp; over {total}",
    pt: "empate e mais de {total}",
    es: "empate y más de {total}"
  },
  "{$competitor2} &amp; under {total}": {
    en: "{$competitor2} &amp; under {total}",
    pt: "{$competitor2} e menos de {total}",
    es: "{$competitor2} &amp; menos de {total}"
  },
  "{$competitor2} &amp; over {total}": {
    en: "{$competitor2} &amp; over {total}",
    pt: "{$competitor2} e mais de {total}",
    es: "{$competitor2} &amp; más de {total}"
  },
  "no goal": { en: "no goal", pt: "sem golo", es: "sin gol" },
  other: { en: "other", pt: "other", es: "otro" },
  "{$competitor1}/{$competitor1}": {
    en: "{$competitor1}/{$competitor1}",
    pt: "{$competitor1}/{$competitor1}",
    es: "{$competitor1}/{$competitor1}"
  },
  "{$competitor1}/draw": {
    en: "{$competitor1}/draw",
    pt: "{$competitor1}/empate",
    es: "{$competitor1}/empate"
  },
  "{$competitor1}/{$competitor2}": {
    en: "{$competitor1}/{$competitor2}",
    pt: "{$competitor1}/{$competitor2}",
    es: "{$competitor1}/{$competitor2}"
  },
  "draw/{$competitor1}": {
    en: "draw/{$competitor1}",
    pt: "empate/{$competitor1}",
    es: "empate/{$competitor1}"
  },
  "draw/draw": { en: "draw/draw", pt: "empate/empate", es: "empate/empate" },
  "draw/{$competitor2}": {
    en: "draw/{$competitor2}",
    pt: "empate/{$competitor2}",
    es: "empate/{$competitor2}"
  },
  "{$competitor2}/{$competitor1}": {
    en: "{$competitor2}/{$competitor1}",
    pt: "{$competitor2}/{$competitor1}",
    es: "{$competitor2}/{$competitor1}"
  },
  "{$competitor2}/draw": {
    en: "{$competitor2}/draw",
    pt: "{$competitor2}/empate",
    es: "{$competitor2}/empate"
  },
  "{$competitor2}/{$competitor2}": {
    en: "{$competitor2}/{$competitor2}",
    pt: "{$competitor2}/{$competitor2}",
    es: "{$competitor2}/{$competitor2}"
  },
  "1st half": { en: "1st half", pt: "1ª parte", es: "1º mitad" },
  "2nd half": { en: "2nd half", pt: "2ª parte", es: "2º mitad" },
  equal: { en: "equal", pt: "igual", es: "igual" },
  "no/no": { en: "no/no", pt: "não/não", es: "no/no" },
  "yes/no": { en: "yes/no", pt: "sim/não", es: "si/no" },
  "yes/yes": { en: "yes/yes", pt: "sim/sim", es: "sí/sí" },
  "no/yes": { en: "no/yes", pt: "não/sim", es: "no/sí" },
  "{$competitor1} goal &amp; {$competitor1}": {
    en: "{$competitor1} goal &amp; {$competitor1}",
    pt: "{$competitor1} golo e {$competitor1}",
    es: "{$competitor1} gol y {$competitor1}"
  },
  "{$competitor1} goal &amp; draw": {
    en: "{$competitor1} goal &amp; draw",
    pt: "{$competitor1} golo e empate",
    es: "{$competitor1} gol y empate"
  },
  "{$competitor1} goal &amp; {$competitor2}": {
    en: "{$competitor1} goal &amp; {$competitor2}",
    pt: "{$competitor1} golo e {$competitor2}",
    es: "{$competitor1} gol y {$competitor2}"
  },
  "{$competitor2} goal &amp; {$competitor1}": {
    en: "{$competitor2} goal &amp; {$competitor1}",
    pt: "{$competitor2} golo e {$competitor1}",
    es: "{$competitor2} gol y {$competitor1}"
  },
  "{$competitor2} goal &amp; draw": {
    en: "{$competitor2} goal &amp; draw",
    pt: "{$competitor2} golo e empate",
    es: "{$competitor2} gol y empate"
  },
  "{$competitor2} goal &amp; {$competitor2}": {
    en: "{$competitor2} goal &amp; {$competitor2}",
    pt: "{$competitor2} golo e {$competitor2}",
    es: "{$competitor2} gol y {$competitor2}"
  },
  "{$competitor1}/draw &amp; yes": {
    en: "{$competitor1}/draw &amp; yes",
    pt: "{$competitor1}/empate e sim",
    es: "{$competitor1}/empate y sí"
  },
  "{$competitor1}/draw &amp; no": {
    en: "{$competitor1}/draw &amp; no",
    pt: "{$competitor1}/empate e não",
    es: "{$competitor1}/empate y no"
  },
  "{$competitor1}/{$competitor2} &amp; yes": {
    en: "{$competitor1}/{$competitor2} &amp; yes",
    pt: "{$competitor1}/{$competitor2} e sim",
    es: "{$competitor1}/{$competitor2} y sí"
  },
  "{$competitor1}/{$competitor2} &amp; no": {
    en: "{$competitor1}/{$competitor2} &amp; no",
    pt: "{$competitor1}/{$competitor2} e não",
    es: "{$competitor1}/{$competitor2} y no"
  },
  "draw/{$competitor2} &amp; yes": {
    en: "draw/{$competitor2} &amp; yes",
    pt: "empate/{$competitor2} e sim",
    es: "empate/{$competitor2} y sí"
  },
  "draw/{$competitor2} &amp; no": {
    en: "draw/{$competitor2} &amp; no",
    pt: "empate/{$competitor2} e não",
    es: "empate/{$competitor2} y no"
  },
  "{$competitor1}/draw &amp; under {total}": {
    en: "{$competitor1}/draw &amp; under {total}",
    pt: "{$competitor1}/empate e menos de {total}",
    es: "{$competitor1}/empate y menos de {total}"
  },
  "{$competitor1}/{$competitor2} &amp; under {total}": {
    en: "{$competitor1}/{$competitor2} &amp; under {total}",
    pt: "{$competitor1}/{$competitor2} e menos de {total}",
    es: "{$competitor1}/{$competitor2} y menos de {total}"
  },
  "draw/{$competitor2} &amp; under {total}": {
    en: "draw/{$competitor2} &amp; under {total}",
    pt: "empate/{$competitor2} e menos de {total}",
    es: "empate/{$competitor2} y menos de {total}"
  },
  "{$competitor1}/draw &amp; over {total}": {
    en: "{$competitor1}/draw &amp; over {total}",
    pt: "{$competitor1}/empate e mais de {total}",
    es: "{$competitor1}/empate y más de {total}"
  },
  "{$competitor1}/{$competitor2} &amp; over {total}": {
    en: "{$competitor1}/{$competitor2} &amp; over {total}",
    pt: "{$competitor1}/{$competitor2} e mais de {total}",
    es: "{$competitor1}/{$competitor2} y más de {total}"
  },
  "draw/{$competitor2} &amp; over {total}": {
    en: "draw/{$competitor2} &amp; over {total}",
    pt: "empate/{$competitor2} e mais de {total}",
    es: "empate/{$competitor2} y más de {total}"
  },
  "1:0, 2:0 or 3:0": {
    en: "1:0, 2:0 or 3:0",
    pt: "1:0, 2:0 ou 3:0",
    es: "1:0, 2:0 o 3:0"
  },
  "0:1, 0:2 or 0:3": {
    en: "0:1, 0:2 or 0:3",
    pt: "0:1, 0:2 ou 0:3",
    es: "0:1, 0:2 o 0:3"
  },
  "4:0, 5:0 or 6:0": {
    en: "4:0, 5:0 or 6:0",
    pt: "4:0, 5:0 ou 6:0",
    es: "4:0, 5:0 o 6:0"
  },
  "0:4, 0:5 or 0:6": {
    en: "0:4, 0:5 or 0:6",
    pt: "0:4, 0:5 ou 0:6",
    es: "0:4, 0:5 o 0:6"
  },
  "2:1, 3:1 or 4:1": {
    en: "2:1, 3:1 or 4:1",
    pt: "2:1, 3:1 ou 4:1",
    es: "2:1, 3:1 o 4:1"
  },
  "1:2, 1:3 or 1:4": {
    en: "1:2, 1:3 or 1:4",
    pt: "1:2, 1:3 ou 1:4",
    es: "1:2, 1:3 o 1:4"
  },
  "3:2, 4:2, 4:3 or 5:1": {
    en: "3:2, 4:2, 4:3 or 5:1",
    pt: "3:2, 4:2, 4:3 ou 5:1",
    es: "3:2, 4:2, 4:3 o 5:1"
  },
  "2:3, 2:4, 3:4 or 1:5": {
    en: "2:3, 2:4, 3:4 or 1:5",
    pt: "2:3, 2:4, 3:4 ou 1:5",
    es: "2:3, 2:4, 3:4 o 1:5"
  },
  "other homewin": {
    en: "other homewin",
    pt: "outra vitórialocal",
    es: "otra victoria local"
  },
  "other awaywin": {
    en: "other awaywin",
    pt: "outra vitóriavisitante",
    es: "otra victoria visitante"
  },
  "{$competitor1}/{$competitor1} &amp; under {total}": {
    en: "{$competitor1}/{$competitor1} &amp; under {total}",
    pt: "{$competitor1}/{$competitor1} e menos {",
    es: "{$competitor1}/{$competitor1} &amp; menos de {total}"
  },
  "draw/{$competitor1} &amp; under {total}": {
    en: "draw/{$competitor1} &amp; under {total}",
    pt: "empate/{$competitor1} e menos {total}",
    es: "empate/{$competitor1} &amp; menos de {total}"
  },
  "draw/draw &amp; under {total}": {
    en: "draw/draw &amp; under {total}",
    pt: "empate/empate e menos {total}",
    es: "empate/empate &amp; menos de {total}"
  },
  "{$competitor2}/{$competitor1} &amp; under {total}": {
    en: "{$competitor2}/{$competitor1} &amp; under {total}",
    pt: "{$competitor2}/{$competitor1} e menos {total}",
    es: "{$competitor2}/{$competitor1} &amp; menos de {total}"
  },
  "{$competitor2}/draw &amp; under {total}": {
    en: "{$competitor2}/draw &amp; under {total}",
    pt: "{$competitor2}/empate e menos {total}",
    es: "{$competitor2}/empate &amp; menos de {total}"
  },
  "{$competitor2}/{$competitor2} &amp; under {total}": {
    en: "{$competitor2}/{$competitor2} &amp; under {total}",
    pt: "{$competitor2}/{$competitor2} e menos {total}",
    es: "{$competitor2}/{$competitor2} &amp; menos de {total}"
  },
  "{$competitor1}/{$competitor1} &amp; over {total}": {
    en: "{$competitor1}/{$competitor1} &amp; over {total}",
    pt: "{$competitor1}/{$competitor1} e mais {total}",
    es: "{$competitor1}/{$competitor1} &amp; más de {total}"
  },
  "draw/{$competitor1} &amp; over {total}": {
    en: "draw/{$competitor1} &amp; over {total}",
    pt: "empate/{$competitor1} e mais {total}",
    es: "empate /{$competitor1} &amp; más de {total}"
  },
  "draw/draw &amp; over {total}": {
    en: "draw/draw &amp; over {total}",
    pt: "empate/empate e mais {total}",
    es: "empate/empate &amp; más de {total}"
  },
  "{$competitor2}/{$competitor1} &amp; over {total}": {
    en: "{$competitor2}/{$competitor1} &amp; over {total}",
    pt: "{$competitor2}/{$competitor1} e mais {total}",
    es: "{$competitor2}/{$competitor1} &amp; más de {total}"
  },
  "{$competitor2}/draw &amp; over {total}": {
    en: "{$competitor2}/draw &amp; over {total}",
    pt: "{$competitor2}/empate e mais {total}",
    es: "{$competitor2}/empate &amp; más de {total}"
  },
  "{$competitor2}/{$competitor2} &amp; over {total}": {
    en: "{$competitor2}/{$competitor2} &amp; over {total}",
    pt: "{$competitor2}/{$competitor2} e mais {total}",
    es: "{$competitor2}/{$competitor2} &amp; más de {total}"
  },
  "draw/draw &amp; 0": {
    en: "draw/draw &amp; 0",
    pt: "empate/empate e 0",
    es: "empate/empate &amp; 0"
  },
  "{$competitor1}/{$competitor1} &amp; 1": {
    en: "{$competitor1}/{$competitor1} &amp; 1",
    pt: "{$competitor1}/{$competitor1} e 1",
    es: "{$competitor1}/{$competitor1} &amp; 1"
  },
  "draw/{$competitor1} &amp; 1": {
    en: "draw/{$competitor1} &amp; 1",
    pt: "empate/{$competitor1} e 1",
    es: "empate/{$competitor1} &amp; 1"
  },
  "draw/{$competitor2} &amp; 1": {
    en: "draw/{$competitor2} &amp; 1",
    pt: "empate/{$competitor2} e 1",
    es: "empate/{$competitor2} &amp; 1"
  },
  "{$competitor2}/{$competitor2} &amp; 1": {
    en: "{$competitor2}/{$competitor2} &amp; 1",
    pt: "{$competitor2}/{$competitor2} e 1",
    es: "{$competitor2}/{$competitor2} &amp; 1"
  },
  "{$competitor1}/{$competitor1} &amp; 2": {
    en: "{$competitor1}/{$competitor1} &amp; 2",
    pt: "{$competitor1}/{$competitor1} e 2",
    es: "{$competitor1}/{$competitor1} &amp; 2"
  },
  "{$competitor1}/draw &amp; 2": {
    en: "{$competitor1}/draw &amp; 2",
    pt: "{$competitor1}/empate e 2",
    es: "{$competitor1}/empate &amp; 2"
  },
  "draw/{$competitor1} &amp; 2": {
    en: "draw/{$competitor1} &amp; 2",
    pt: "empate/{$competitor1} e 2",
    es: "empate/{$competitor1} &amp; 2"
  },
  "draw/draw &amp; 2": {
    en: "draw/draw &amp; 2",
    pt: "empate/empate e 2",
    es: "empate/empate &amp; 2"
  },
  "draw/{$competitor2} &amp; 2": {
    en: "draw/{$competitor2} &amp; 2",
    pt: "empate/{$competitor2} e 2",
    es: "empate/{$competitor2} &amp; 2"
  },
  "{$competitor2}/draw &amp; 2": {
    en: "{$competitor2}/draw &amp; 2",
    pt: "{$competitor2}/empate e 2",
    es: "{$competitor2}/empate&amp; 2"
  },
  "{$competitor2}/{$competitor2} &amp; 2": {
    en: "{$competitor2}/{$competitor2} &amp; 2",
    pt: "{$competitor2}/{$competitor2} e 2",
    es: "{$competitor2}/{$competitor2} &amp; 2"
  },
  "{$competitor1}/{$competitor1} &amp; 3": {
    en: "{$competitor1}/{$competitor1} &amp; 3",
    pt: "{$competitor1}/{$competitor1} e 3",
    es: "{$competitor1}/{$competitor1} &amp; 3"
  },
  "{$competitor1}/{$competitor2} &amp; 3": {
    en: "{$competitor1}/{$competitor2} &amp; 3",
    pt: "{$competitor1}/{$competitor2} e 3",
    es: "{$competitor1}/{$competitor2} &amp; 3"
  },
  "draw/{$competitor1} &amp; 3": {
    en: "draw/{$competitor1} &amp; 3",
    pt: "empate/{$competitor1} e 3",
    es: "empate/{$competitor1} &amp; 3"
  },
  "draw/{$competitor2} &amp; 3": {
    en: "draw/{$competitor2} &amp; 3",
    pt: "empate/{$competitor2} e 3",
    es: "empate/{$competitor2} &amp; 3"
  },
  "{$competitor2}/{$competitor1} &amp; 3": {
    en: "{$competitor2}/{$competitor1} &amp; 3",
    pt: "{$competitor2}/{$competitor1} e 3",
    es: "{$competitor2}/{$competitor1} &amp; 3"
  },
  "{$competitor2}/{$competitor2} &amp; 3": {
    en: "{$competitor2}/{$competitor2} &amp; 3",
    pt: "{$competitor2}/{$competitor2} e 3",
    es: "{$competitor2}/{$competitor2} &amp; 3"
  },
  "{$competitor1}/{$competitor1} &amp; 4": {
    en: "{$competitor1}/{$competitor1} &amp; 4",
    pt: "{$competitor1}/{$competitor1} e 4",
    es: "{$competitor1}/{$competitor1} &amp; 4"
  },
  "{$competitor1}/draw &amp; 4": {
    en: "{$competitor1}/draw &amp; 4",
    pt: "{$competitor1}/empate e 4",
    es: "{$competitor1}/empate &amp; 4"
  },
  "{$competitor1}/{$competitor2} &amp; 4": {
    en: "{$competitor1}/{$competitor2} &amp; 4",
    pt: "{$competitor1}/{$competitor2} e 4",
    es: "{$competitor1}/{$competitor2} &amp; 4"
  },
  "draw/{$competitor1} &amp; 4": {
    en: "draw/{$competitor1} &amp; 4",
    pt: "empate/{$competitor1} e 4",
    es: "empate/{$competitor1} &amp; 4"
  },
  "draw/draw &amp; 4": {
    en: "draw/draw &amp; 4",
    pt: "empate/empate e 4",
    es: "empate/empate &amp; 4"
  },
  "draw/{$competitor2} &amp; 4": {
    en: "draw/{$competitor2} &amp; 4",
    pt: "empate/{$competitor2} e 4",
    es: "empate/{$competitor2} &amp; 4"
  },
  "{$competitor2}/{$competitor1} &amp; 4": {
    en: "{$competitor2}/{$competitor1} &amp; 4",
    pt: "{$competitor2}/{$competitor1} e 4",
    es: "{$competitor2}/{$competitor1} &amp; 4"
  },
  "{$competitor2}/draw &amp; 4": {
    en: "{$competitor2}/draw &amp; 4",
    pt: "{$competitor2}/empate e 4",
    es: "{$competitor2}/empate &amp; 4"
  },
  "{$competitor2}/{$competitor2} &amp; 4": {
    en: "{$competitor2}/{$competitor2} &amp; 4",
    pt: "{$competitor2}/{$competitor2} e 4",
    es: "{$competitor2}/{$competitor2} &amp; 4"
  },
  "{$competitor1}/{$competitor1} &amp; 5+": {
    en: "{$competitor1}/{$competitor1} &amp; 5+",
    pt: "{$competitor1}/{$competitor1} e 5+",
    es: "{$competitor1}/{$competitor1} &amp; 5+"
  },
  "{$competitor1}/draw &amp; 5+": {
    en: "{$competitor1}/draw &amp; 5+",
    pt: "{$competitor1}/empate e 5+",
    es: "{$competitor1}/empate &amp; 5+"
  },
  "{$competitor1}/{$competitor2} &amp; 5+": {
    en: "{$competitor1}/{$competitor2} &amp; 5+",
    pt: "{$competitor1}/{$competitor2} e 5+",
    es: "{$competitor1}/{$competitor2} &amp; 5+"
  },
  "draw/{$competitor1} &amp; 5+": {
    en: "draw/{$competitor1} &amp; 5+",
    pt: "empate/{$competitor1} e 5+",
    es: "empate/{$competitor1} &amp; 5+"
  },
  "draw/draw &amp; 5+": {
    en: "draw/draw &amp; 5+",
    pt: "empate/empate e +5",
    es: "empate/empate &amp; 5+"
  },
  "draw/{$competitor2} &amp; 5+": {
    en: "draw/{$competitor2} &amp; 5+",
    pt: "empate/{$competitor2} e 5+",
    es: "empate/{$competitor2} &amp; 5+"
  },
  "{$competitor2}/{$competitor1} &amp; 5+": {
    en: "{$competitor2}/{$competitor1} &amp; 5+",
    pt: "{$competitor2}/{$competitor1} e 5+",
    es: "{$competitor2}/{$competitor1} &amp; 5+"
  },
  "{$competitor2}/draw &amp; 5+": {
    en: "{$competitor2}/draw &amp; 5+",
    pt: "{$competitor2}/empate e 5+",
    es: "{$competitor2}/empate &amp; 5+"
  },
  x: {
    en: "draw",
    es: "empate",
    pt: "empate"
  },
  "{$competitor2}/{$competitor2} &amp; 5+": {
    en: "{$competitor2}/{$competitor2} &amp; 5+",
    pt: "{$competitor2}/{$competitor2} e 5+",
    es: "{$competitor2}/{$competitor2} &amp; 5+"
  },
  "goal before 29:00 min.": {
    en: "goal before 29:00 min.",
    pt: "goal before 29:00 min.",
    es: "goal before 29:00 min."
  },
  "no goal before 29:00 min.": {
    en: "no goal before 29:00 min.",
    pt: "no goal before 29:00 min.",
    es: "no goal before 29:00 min."
  },
  "over 7.5": { en: "over 7.5", pt: "mais de 7.5", es: "más de 7.5" },
  "under 7.5": { en: "under 7.5", pt: "menos de 7.5", es: "menos de 7.5" },
  "over 8.5": { en: "over 8.5", pt: "mais de 8.5", es: "más de 8.5" },
  "under 8.5": { en: "under 8.5", pt: "menos de 8.5", es: "menos de 8.5" },
  "over 9.5": { en: "over 9.5", pt: "mais de 9.5", es: "más de 9.5" },
  "under 9.5": { en: "under 9.5", pt: "menos de 9.5", es: "menos de 9.5" },
  "over 10.5": { en: "over 10.5", pt: "mais de 10.5", es: "más de 10.5" },
  "under 10.5": { en: "under 10.5", pt: "menos de 10.5", es: "menos de 10.5" },
  "over 11.5": { en: "over 11.5", pt: "mais de 11.5", es: "más de 11.5" },
  "under 11.5": { en: "under 11.5", pt: "menos de 11.5", es: "menos de 11.5" },
  "over 12.5": { en: "over 12.5", pt: "mais de 12.5", es: "más de 12.5" },
  "under 12.5": { en: "under 12.5", pt: "menos de 12.5", es: "menos de 12.5" },
  "over 13.5": { en: "over 13.5", pt: "mais de 13.5", es: "más de 13.5" },
  "under 13.5": { en: "under 13.5", pt: "menos de 13.5", es: "menos de 13.5" },
  "over 14.5": { en: "over 14.5", pt: "mais de 14.5", es: "más de 14.5" },
  "under 14.5": { en: "under 14.5", pt: "menos de 14.5", es: "menos de 14.5" },
  "over 3.5": { en: "over 3.5", pt: "mais de 3.5", es: "más de 3.5" },
  "under 3.5": { en: "under 3.5", pt: "menos de 3.5", es: "menos de 3.5" },
  "over 4.5": { en: "over 4.5", pt: "mais de 4.5", es: "más de 4.5" },
  "under 4.5": { en: "under 4.5", pt: "menos de 4.5", es: "menos de 4.5" },
  "over 5.5": { en: "over 5.5", pt: "mais de 5.5", es: "más de 5.5" },
  "under 5.5": { en: "under 5.5", pt: "menos de 5.5", es: "menos de 5.5" },
  "1-1": { en: "1-1", pt: "1-1", es: "1-1" },
  "1-x": { en: "1-x", pt: "1-empate", es: "1-empate" },
  "x-1": { en: "draw-1", pt: "empate-1", es: "empate-1" },
  "x-x": { en: "draw-draw", pt: "empate-empate", es: "empate-empate" },
  "x-2": { en: "draw-2", pt: "empate-2", es: "empate-2" },
  "2-1": { en: "2-1", pt: "2-1", es: "2-1" },
  "2-x": { en: "2-draw", pt: "2-empate", es: "2-empate" },
  "2-2": { en: "2-2", pt: "2-2", es: "2-2" },
  neither: { en: "neither", pt: "neither", es: "neither" },
  over: { en: "over", pt: "mais de", es: "más de" },
  under: { en: "under", pt: "menos de", es: "menos de" },
  o: { en: "over", pt: "mais de", es: "más de" },
  u: { en: "under", pt: "menos de", es: "menos de" },
  "1st quarter": { en: "1st quarter", pt: "1º quarto", es: "1º cuarto" },
  "2nd quarter": { en: "2nd quarter", pt: "2º quarto", es: "2º cuarto" },
  "3rd quarter": { en: "3rd quarter", pt: "3º quarto", es: "3º cuarto" },
  "4th quarter": { en: "4th quarter", pt: "4º quarto", es: "4º cuarto" },
  "{$competitor1} by 6+": {
    en: "{$competitor1} by 6+",
    pt: "{$competitor1} by 6+",
    es: "{$competitor1} por 6+"
  },
  "{$competitor2} by 6+": {
    en: "{$competitor2} by 6+",
    pt: "{$competitor2} by 6+",
    es: "{$competitor2} por 6+"
  },
  "{$competitor1} by 11-15": {
    en: "{$competitor1} by 11-15",
    pt: "{$competitor1} by 11-15",
    es: "{$competitor1} por 11-15"
  },
  "{$competitor1} by 16-20": {
    en: "{$competitor1} by 16-20",
    pt: "{$competitor1} by 16-20",
    es: "{$competitor1} por 16-20"
  },
  "{$competitor1} by 21-25": {
    en: "{$competitor1} by 21-25",
    pt: "{$competitor1} by 21-25",
    es: "{$competitor1} por 21-25"
  },
  "{$competitor1} by 26+": {
    en: "{$competitor1} by 26+",
    pt: "{$competitor1} by 26+",
    es: "{$competitor1} por 26+"
  },
  "{$competitor2} by 11-15": {
    en: "{$competitor2} by 11-15",
    pt: "{$competitor2} by 11-15",
    es: "{$competitor2} por 11-15"
  },
  "{$competitor2} by 16-20": {
    en: "{$competitor2} by 16-20",
    pt: "{$competitor2} by 16-20",
    es: "{$competitor2} por 16-20"
  },
  "{$competitor2} by 21-25": {
    en: "{$competitor2} by 21-25",
    pt: "{$competitor2} by 21-25",
    es: "{$competitor2} por 21-25"
  },
  "{$competitor2} by 26+": {
    en: "{$competitor2} by 26+",
    pt: "{$competitor2} by 26+",
    es: "{$competitor2} por 26+"
  },
  "exact {total}": {
    en: "exact {total}",
    pt: "exato {total}",
    es: "exacto {total}"
  },
  "{$competitor1} ({+hcp}) &amp;amp; over {total}": {
    en: "{$competitor1} ({+hcp}) &amp;amp; over {total}",
    pt: "{$competitor1} ({+hcp}) &amp;amp; over {total}",
    es: "{$competitor1} ({+hcp}) &amp;amp; mas de {total}"
  },
  "{$competitor1} ({+hcp}) &amp;amp; under {total}": {
    en: "{$competitor1} ({+hcp}) &amp;amp; under {total}",
    pt: "{$competitor1} ({+hcp}) &amp;amp; under {total}",
    es: "{$competitor1} ({+hcp}) &amp;amp; menos de {total}"
  },
  "{$competitor2} ({-hcp}) &amp;amp; over {total}": {
    en: "{$competitor2} ({-hcp}) &amp;amp; over {total}",
    pt: "{$competitor2} ({-hcp}) &amp;amp; over {total}",
    es: "{$competitor2} ({-hcp}) &amp;amp; mas de {total}"
  },
  "{{$competitor2} ({-hcp}) &amp;amp; under {total}": {
    en: "{{$competitor2} ({-hcp}) &amp;amp; under {total}",
    pt: "{{$competitor2} ({-hcp}) &amp;amp; under {total}",
    es: "{{$competitor2} ({-hcp}) &amp;amp; menos de {total}"
  },
  "{$competitor1} &amp;amp; under {total}": {
    en: "{$competitor1} &amp;amp; under {total}",
    pt: "{$competitor1} &amp;amp; under {total}",
    es: "{$competitor1} &amp;amp; menos de {total}"
  },
  "{$competitor1} &amp;amp; over {total}": {
    en: "{$competitor1} &amp;amp; over {total}",
    pt: "{$competitor1} &amp;amp; over {total}",
    es: "{$competitor1} &amp;amp; mas de {total}"
  },
  "draw &amp;amp; under {total}": {
    en: "draw &amp;amp; under {total}",
    pt: "empate &amp;amp; under {total}",
    es: "empate &amp;amp; menos de {total}"
  },
  "draw &amp;amp; over {total}": {
    en: "draw &amp;amp; over {total}",
    pt: "empate &amp;amp; over {total}",
    es: "empate &amp;amp; mas de {total}"
  },
  "{$competitor2} &amp;amp; under {total}": {
    en: "{$competitor2} &amp;amp; under {total}",
    pt: "{$competitor2} &amp;amp; under {total}",
    es: "{$competitor2} &amp;amp; menos de {total}"
  },
  "{$competitor2} &amp;amp; over {total}": {
    en: "{$competitor2} &amp;amp; over {total}",
    pt: "{$competitor2} &amp;amp; over {total}",
    es: "{$competitor2} &amp;amp; mas de {total}"
  },
  "{$competitor2} ({-hcp}) &amp;amp; under {total}": {
    en: "{$competitor2} ({-hcp}) &amp;amp; under {total}",
    pt: "{$competitor2} ({-hcp}) &amp;amp; under {total}",
    es: "{$competitor2} ({-hcp}) &amp;amp; menos de {total}"
  },
  "1st inning": { en: "1st inning", pt: "1º inning", es: "1º inning" },
  "2nd inning": { en: "2nd inning", pt: "2º inning", es: "2º inning" },
  "3rd inning": { en: "3rd inning", pt: "3º inning", es: "3º inning" },
  "4th inning": { en: "4th inning", pt: "4º inning", es: "4º inning" },
  "5th inning": { en: "5th inning", pt: "5º inning", es: "5º inning" },
  "6th inning": { en: "6th inning", pt: "6º inning", es: "6º inning" },
  "7th inning": { en: "7th inning", pt: "7º inning", es: "7º inning" },
  "8th inning": { en: "8th inning", pt: "8º inning", es: "8º inning" },
  "9th inning": { en: "9th inning", pt: "9º inning", es: "9º inning" },
  "top of 9th inning": {
    en: "top of 9th inning",
    pt: "melhor do 9º inning",
    es: "mejor del 9º inning"
  },
  "bottom of 9th inning": {
    en: "bottom of 9th inning",
    pt: "pior do 9º inning",
    es: "peor del 9º inning"
  },
  "any extra inning": {
    en: "any extra inning",
    pt: "qualquer inning extra",
    es: "cualquier extra inning"
  },
  "{!inningnr} inning": {
    en: "{!inningnr} inning",
    pt: "{!inningnr} inning",
    es: "{!inningnr} inning"
  },
  "{!(inningnr+1)} inning": {
    en: "{!(inningnr+1)} inning",
    pt: "{!(inningnr+1)} inning",
    es: "{!(inningnr+1)} inning"
  },
  "{!(inningnr+2)} inning": {
    en: "{!(inningnr+2)} inning",
    pt: "{!(inningnr+2)} inning",
    es: "{!(inningnr+2)} inning"
  },
  "other inning or no run": {
    en: "other inning or no run",
    pt: "outro inning ou sem run",
    es: "otro inning o sin carrera"
  },
  "1st period": { en: "1st period", pt: "1º período", es: "1º periodo" },
  "2nd period": { en: "2nd period", pt: "2º período", es: "2º periodo" },
  "3rd period": { en: "3rd period", pt: "3º período", es: "3º periodo" },
  "{$competitor1} by ko": {
    en: "{$competitor1} by ko",
    pt: "{$competitor1} by ko",
    es: "{$competitor1} por ko"
  },
  "{$competitor1} by submission": {
    en: "{$competitor1} by submission",
    pt: "{$competitor1} by submission",
    es: "{$competitor1} por submission"
  },
  "{$competitor1} by decision": {
    en: "{$competitor1} by decision",
    pt: "{$competitor1} by decision",
    es: "{$competitor1} por decision"
  },
  "{$competitor2} by ko": {
    en: "{$competitor2} by ko",
    pt: "{$competitor2} by ko",
    es: "{$competitor2} por ko"
  },
  "{$competitor2} by submission": {
    en: "{$competitor2} by submission",
    pt: "{$competitor2} by submission",
    es: "{$competitor2} por submission"
  },
  "{$competitor2} by decision": {
    en: "{$competitor2} by decision",
    pt: "{$competitor2} by decision",
    es: "{$competitor2} por decision"
  },
  "{$competitor1} &amp;amp; decision": {
    en: "{$competitor1} &amp;amp; decision",
    pt: "{$competitor1} &amp;amp; decision",
    es: "{$competitor1} &amp;amp; decision"
  },
  "{$competitor2} &amp;amp; 1": {
    en: "{$competitor2} &amp;amp; 1",
    pt: "{$competitor2} &amp;amp; 1",
    es: "{$competitor2} &amp;amp; 1"
  },
  "{$competitor2} &amp;amp; decision": {
    en: "{$competitor2} &amp;amp; decision",
    pt: "{$competitor2} &amp;amp; decision",
    es: "{$competitor2} &amp;amp; decision"
  },
  "{$competitor1} with try": {
    en: "{$competitor1} with try",
    pt: "{$competitor1} com ensaio",
    es: "{$competitor1} con try"
  },
  "{$competitor1} with penalty": {
    en: "{$competitor1} with penalty",
    pt: "{$competitor1} com penalty",
    es: "{$competitor1} con penal"
  },
  "{$competitor1} with drop goal": {
    en: "{$competitor1} with drop goal",
    pt: "{$competitor1} com drop goal",
    es: "{$competitor1} con drop goal"
  },
  "{$competitor2} with try": {
    en: "{$competitor2} with try",
    pt: "{$competitor2} com ensaio",
    es: "{$competitor2} con try"
  },
  "{$competitor2} with penalty": {
    en: "{$competitor2} with penalty",
    pt: "{$competitor2} com penalty",
    es: "{$competitor2} con penal"
  },
  "{$competitor2} with drop goal": {
    en: "{$competitor2} with drop goal",
    pt: "{$competitor2} com drop goal",
    es: "{$competitor2} con drop goal"
  },

  /////////////////////////////////prelive tranalation///////////////////////////////////////////

  "{$competitor1} & no": {
    pt: "{$competitor1} e não",
    en: "{$competitor1} & no",
    es: "{$competitor1} y no"
  },
  "draw & yes": { pt: "empate e sim", en: "draw & yes", es: "empate y sí" },
  "draw & no": { pt: "empate e não", en: "draw & no", es: "empate y no" },
  "{$competitor2} & yes": {
    pt: "{$competitor2} e sim",
    en: "{$competitor2} & yes",
    es: "{$competitor2} y sí"
  },
  "{$competitor2} & no": {
    pt: "{$competitor2} e não",
    en: "{$competitor2} & no",
    es: "{$competitor2} y no"
  },
  "over {total} & yes": {
    pt: "mais de {total} e sim",
    en: "over {total} & yes",
    es: "más de {total} y sí"
  },
  "under {total} & yes": {
    pt: "menos de {total} e sim",
    en: "under {total} & yes",
    es: "menos de {total} y sí"
  },
  "over {total} & no": {
    pt: "mais de {total} e não",
    en: "over {total} & no",
    es: "más de {total} y no"
  },
  "under {total} & no": {
    pt: "menos de {total} e não",
    en: "under {total} & no",
    es: "menos de {total} y no"
  },
  "{$competitor1} & under {total}": {
    pt: "{$competitor1} e menos de {total}",
    en: "{$competitor1} & under {total}",
    es: "{$competitor1} y menos de {total}"
  },
  "{$competitor1} & over {total}": {
    pt: "{$competitor1} e mais de {total}",
    en: "{$competitor1} & over {total}",
    es: "{$competitor1} y más de {total}"
  },
  "draw & under {total}": {
    pt: "empate e menos de {total}",
    en: "draw & under {total}",
    es: "empate y menos de {total}"
  },
  "draw & over {total}": {
    pt: "empate e mais de {total}",
    en: "draw & over {total}",
    es: "empate y más de {total}"
  },
  "{$competitor2} & under {total}": {
    pt: "{$competitor2} e menos de {total}",
    en: "{$competitor2} & under {total}",
    es: "{$competitor2} y menos de {total}"
  },
  "{$competitor2} & over {total}": {
    pt: "{$competitor2} e mais de {total}",
    en: "{$competitor2} & over {total}",
    es: "{$competitor2} y más de {total}"
  },
  "{$competitor1} goal & {$competitor1}": {
    pt: "{$competitor1} golo e {$competitor1}",
    en: "{$competitor1} goal & {$competitor1}",
    es: "{$competitor1} gol y {$competitor1}"
  },
  "{$competitor1} goal & draw": {
    pt: "{$competitor1} golo e empate",
    en: "{$competitor1} goal & draw",
    es: "{$competitor1} gol y empate"
  },
  "{$competitor1} goal & {$competitor2}": {
    pt: "{$competitor1} golo e {$competitor2}",
    en: "{$competitor1} goal & {$competitor2}",
    es: "{$competitor1} gol y {$competitor2}"
  },
  "{$competitor2} goal & {$competitor1}": {
    pt: "{$competitor2} golo e {$competitor1}",
    en: "{$competitor2} goal & {$competitor1}",
    es: "{$competitor2} gol y {$competitor1}"
  },
  "{$competitor2} goal & draw": {
    pt: "{$competitor2} golo e empate",
    en: "{$competitor2} goal & draw",
    es: "{$competitor2} gol y empate"
  },
  "{$competitor2} goal & {$competitor2}": {
    pt: "{$competitor2} golo e {$competitor2}",
    en: "{$competitor2} goal & {$competitor2}",
    es: "{$competitor2} gol y {$competitor2}"
  },
  "{$competitor1} to 0": {
    pt: "{$competitor1} a 0",
    en: "{$competitor1} to 0",
    es: "{$competitor1} a 0"
  },
  "{$competitor1} to 15": {
    pt: "{$competitor1} a 15",
    en: "{$competitor1} to 15",
    es: "{$competitor1} a 15"
  },
  "{$competitor1} to 30": {
    pt: "{$competitor1} a 30",
    en: "{$competitor1} to 30",
    es: "{$competitor1} a 30"
  },
  "{$competitor1} to 40": {
    pt: "{$competitor1} a 40",
    en: "{$competitor1} to 40",
    es: "{$competitor1} a 40"
  },
  "{$competitor2} to 0": {
    pt: "{$competitor2} a 0",
    en: "{$competitor2} to 0",
    es: "{$competitor2} a 0"
  },
  "{$competitor2} to 15": {
    pt: "{$competitor2} a 15",
    en: "{$competitor2} to 15",
    es: "{$competitor2} a 15"
  },
  "{$competitor2} to 30": {
    pt: "{$competitor2} a 30",
    en: "{$competitor2} to 30",
    es: "{$competitor2} a 30"
  },
  "{$competitor2} to 40": {
    pt: "{$competitor2} a 40",
    en: "{$competitor2} to 40",
    es: "{$competitor2} a 40"
  },
  "{%server} to 0": {
    pt: "{%server} a 0",
    en: "{%server} to 0",
    es: "{%server} a 0"
  },
  "{%server} to 15": {
    pt: "{%server} a 15",
    en: "{%server} to 15",
    es: "{%server} a 15"
  },
  "{%server} to 30": {
    pt: "{%server} a 30",
    en: "{%server} to 30",
    es: "{%server} a 30"
  },
  "{%server} to 40": {
    pt: "{%server} a 40",
    en: "{%server} to 40",
    es: "{%server} a 40"
  },
  break: { pt: "break", en: "break", es: "break" },
  touchdown: { pt: "touchdown", en: "touchdown", es: "touchdown" },
  fieldgoal: { pt: "fieldgoal", en: "fieldgoal", es: "goldecampo" },
  caught: { pt: "apanhado", en: "caught", es: "caught" },
  bowled: { pt: "lançado", en: "bowled", es: "lanzado" },
  lbw: { pt: "lbw", en: "lbw", es: "lbw" },
  "run out": { pt: "run fora", en: "run out", es: "run out" },
  stumped: { pt: "stumped", en: "stumped", es: "stumped" },
  others: { pt: "outros", en: "others", es: "otros" },
  "not caught": { pt: "não apanhado", en: "not caught", es: "no  caught" },
  red: { pt: "vermelho", en: "red", es: "rojo" },
  green: { pt: "verde", en: "green", es: "verde" },
  "own goal": { es: "en propia puerta", en: "own goal" },
  both: { pt: "ambos", en: "both", es: "ambos" },
  "draw & {$competitor1}": {
    pt: "empate e {$competitor1}",
    en: "draw & {$competitor1}",
    es: "empate y {$competitor1}"
  },
  "draw & {$competitor2}": {
    pt: "empate e {$competitor2}",
    en: "draw & {$competitor2}",
    es: "empate y {$competitor2}"
  },
  "{$competitor1} & draw": {
    pt: "{$competitor1} e empate",
    en: "{$competitor1} & draw",
    es: "{$competitor1} y empate"
  },
  "draw & draw": {
    pt: "empate e empate",
    en: "draw & draw",
    es: "empate y empate"
  },
  "{$competitor2} & draw": {
    pt: "{$competitor2} e empate",
    en: "{$competitor2} & draw",
    es: "{$competitor2} y empate"
  },
  yellow: { pt: "amarelo", en: "yellow", es: "amarilla" },
  brown: { pt: "castanho", en: "brown", es: "marrón" },
  blue: { pt: "azul", en: "blue", es: "azul" },
  pink: { pt: "rosa", en: "pink", es: "rosa" },
  black: { pt: "preto", en: "black", es: "negro" },
  foul: { pt: "falta", en: "foul", es: "falta" },
  "{$competitor1}/draw & yes": {
    pt: "{$competitor1}/empate e sim",
    en: "{$competitor1}/draw & yes",
    es: "{$competitor1}/empate y sí"
  },
  "{$competitor1}/draw & no": {
    pt: "{$competitor1}/empate e não",
    en: "{$competitor1}/draw & no",
    es: "{$competitor1}/empate y no"
  },
  "{$competitor1}/{$competitor2} & yes": {
    pt: "{$competitor1}/{$competitor2} e sim",
    en: "{$competitor1}/{$competitor2} & yes",
    es: "{$competitor1}/{$competitor2} y sí"
  },
  "{$competitor1}/{$competitor2} & no": {
    pt: "{$competitor1}/{$competitor2} e não",
    en: "{$competitor1}/{$competitor2} & no",
    es: "{$competitor1}/{$competitor2} y no"
  },
  "draw/{$competitor2} & yes": {
    pt: "empate/{$competitor2} e sim",
    en: "draw/{$competitor2} & yes",
    es: "empate/{$competitor2} y sí"
  },
  "draw/{$competitor2} & no": {
    pt: "empate/{$competitor2} e não",
    en: "draw/{$competitor2} & no",
    es: "empate/{$competitor2} y no"
  },
  "{$competitor1}/draw & under {total}": {
    pt: "{$competitor1}/empate e menos {total}",
    en: "{$competitor1}/draw & under {total}",
    es: "{$competitor1}/empate& menos de {total}"
  },
  "{$competitor1}/{$competitor2} & under {total}": {
    pt: "{$competitor1}/{$competitor2} e menos {total}",
    en: "{$competitor1}/{$competitor2} & under {total}",
    es: "{$competitor1}/{$competitor2} & menos de {total}"
  },
  "draw/{$competitor2} & under {total}": {
    pt: "empate/{$competitor2} e menos {total}",
    en: "draw/{$competitor2} & under {total}",
    es: "empate/{$competitor2} & menos de {total}"
  },
  "{$competitor1}/draw & over {total}": {
    pt: "{$competitor1}/empate e mais {total}",
    en: "{$competitor1}/draw & over {total}",
    es: "{$competitor1}/empate & más de {total}"
  },
  "{$competitor1}/{$competitor2} & over {total}": {
    pt: "{$competitor1}/{$competitor2} e mais {total}",
    en: "{$competitor1}/{$competitor2} & over {total}",
    es: "{$competitor1}/{$competitor2} & más de {total}"
  },
  "draw/{$competitor2} & over {total}": {
    pt: "empate/{$competitor2} e mais {total}",
    en: "draw/{$competitor2} & over {total}",
    es: "empate/{$competitor2} & más de {total}"
  },
  "high left": {
    pt: "alta esquerda",
    en: "high left",
    es: "alta izquierda"
  },
  "low left": { pt: "baixa esquerda", en: "low left", es: "baja izquierda" },
  "high center": { pt: "alta centro", en: "high center", es: "alta centro" },
  "low center": { pt: "baixa centro", en: "low center", es: "baja centro" },
  "high right": { pt: "alta direita", en: "high right", es: "alta derecha" },
  "low right": {
    pt: "baixa esquerda",
    en: "low right",
    es: "baja izquierda"
  },
  "fielder catch": {
    pt: "fielder catch",
    en: "fielder catch",
    es: "fielder catch"
  },
  "keeper catch": {
    pt: "keeper catch",
    en: "keeper catch",
    es: "keeper catch"
  },
  "home teams": {
    pt: "equipas locais",
    en: "home teams",
    es: "equipos locales"
  },
  "away teams": {
    pt: "equipas visitantes",
    en: "away teams",
    es: "equipos visitantes"
  },
  "{$competitor1}/{$competitor1} & under {total}": {
    pt: "{$competitor1}/{$competitor1} e menos {total}",
    en: "{$competitor1}/{$competitor1} & under {total}",
    es: "{$competitor1}/{$competitor1} & menos de {total}"
  },
  "draw/{$competitor1} & under {total}": {
    pt: "empate/{$competitor1} e menos {total}",
    en: "draw/{$competitor1} & under {total}",
    es: "empate/{$competitor1} & menos de {total}"
  },
  "draw/draw & under {total}": {
    pt: "empate/empate e menos {total}",
    en: "draw/draw & under {total}",
    es: "empate/empate & menos de {total}"
  },
  "{$competitor2}/{$competitor1} & under {total}": {
    pt: "{$competitor2}/{$competitor1} e menos {total}",
    en: "{$competitor2}/{$competitor1} & under {total}",
    es: "{$competitor2}/{$competitor1} & menos de {total}"
  },
  "{$competitor2}/draw & under {total}": {
    pt: "{$competitor2}/empate e menos {total}",
    en: "{$competitor2}/draw & under {total}",
    es: "{$competitor2}/empate & menos de {total}"
  },
  "{$competitor2}/{$competitor2} & under {total}": {
    pt: "{$competitor2}/{$competitor2} e menos {total}",
    en: "{$competitor2}/{$competitor2} & under {total}",
    es: "{$competitor2}/{$competitor2} & menos de {total}"
  },
  "{$competitor1}/{$competitor1} & over {total}": {
    pt: "{$competitor1}/{$competitor1} e mais {total}",
    en: "{$competitor1}/{$competitor1} & over {total}",
    es: "{$competitor1}/{$competitor1} & más de {total}"
  },
  "draw/{$competitor1} & over {total}": {
    pt: "empate/{$competitor1} e mais {total}",
    en: "draw/{$competitor1} & over {total}",
    es: "empate /{$competitor1} & más de {total}"
  },
  "draw/draw & over {total}": {
    pt: "empate/empate e mais {total}",
    en: "draw/draw & over {total}",
    es: "empate/empate & más de {total}"
  },
  "{$competitor2}/{$competitor1} & over {total}": {
    pt: "{$competitor2}/{$competitor1} e mais {total}",
    en: "{$competitor2}/{$competitor1} & over {total}",
    es: "{$competitor2}/{$competitor1} & más de {total}"
  },
  "{$competitor2}/draw & over {total}": {
    pt: "{$competitor2}/empate e mais {total}",
    en: "{$competitor2}/draw & over {total}",
    es: "{$competitor2}/empate & más de {total}"
  },
  "{$competitor2}/{$competitor2} & over {total}": {
    pt: "{$competitor2}/{$competitor2} e mais {total}",
    en: "{$competitor2}/{$competitor2} & over {total}",
    es: "{$competitor2}/{$competitor2} & más de {total}"
  },
  "draw/draw & 0": {
    pt: "empate/empate e 0",
    en: "draw/draw & 0",
    es: "empate/empate & 0"
  },
  "draw/{$competitor1} & 1": {
    pt: "empate/{$competitor1} e 1",
    en: "draw/{$competitor1} & 1",
    es: "empate/{$competitor1} & 1"
  },
  "draw/{$competitor2} & 1": {
    pt: "empate/{$competitor2} e 1",
    en: "draw/{$competitor2} & 1",
    es: "empate/{$competitor2} & 1"
  },
  "{$competitor1}/draw & 2": {
    pt: "{$competitor1}/empate e 2",
    en: "{$competitor1}/draw & 2",
    es: "{$competitor1}/empate & 2"
  },
  "draw/{$competitor1} & 2": {
    pt: "empate/{$competitor1} e 2",
    en: "draw/{$competitor1} & 2",
    es: "empate/{$competitor1} & 2"
  },
  "draw/draw & 2": {
    pt: "empate/empate e 2",
    en: "draw/draw & 2",
    es: "empate/empate & 2"
  },
  "draw/{$competitor2} & 2": {
    pt: "empate/{$competitor2} e 2",
    en: "draw/{$competitor2} & 2",
    es: "empate/{$competitor2} & 2"
  },
  "{$competitor2}/draw & 2": {
    pt: "{$competitor2}/empate e 2",
    en: "{$competitor2}/draw & 2",
    es: "{$competitor2}/empate & 2"
  },
  "draw/{$competitor1} & 3": {
    pt: "empate/{$competitor1} e 3",
    en: "draw/{$competitor1} & 3",
    es: "empate/{$competitor1} & 3"
  },
  "draw/{$competitor2} & 3": {
    pt: "empate/{$competitor2} e 3",
    en: "draw/{$competitor2} & 3",
    es: "empate/{$competitor2} & 3"
  },
  "{$competitor1}/draw & 4": {
    pt: "{$competitor1}/empate e 4",
    en: "{$competitor1}/draw & 4",
    es: "{$competitor1}/empate & 4"
  },
  "draw/{$competitor1} & 4": {
    pt: "empate/{$competitor1} e 4",
    en: "draw/{$competitor1} & 4",
    es: "empate/{$competitor1} & 4"
  },
  "draw/draw & 4": {
    pt: "empate/empate e 4",
    en: "draw/draw & 4",
    es: "empate/empate & 4"
  },
  "draw/{$competitor2} & 4": {
    pt: "empate/{$competitor2} e 4",
    en: "draw/{$competitor2} & 4",
    es: "empate/{$competitor2} & 4"
  },
  "{$competitor2}/draw & 4": {
    pt: "{$competitor2}/empate e 4",
    en: "{$competitor2}/draw & 4",
    es: "{$competitor2}/empate & 4"
  },
  "{$competitor1}/draw & 5+": {
    pt: "{$competitor1}/empate e 5+",
    en: "{$competitor1}/draw & 5+",
    es: "{$competitor1}/empate & 5+"
  },
  "draw/{$competitor1} & 5+": {
    pt: "empate/{$competitor1} e 5+",
    en: "draw/{$competitor1} & 5+",
    es: "empate/{$competitor1} & 5+"
  },
  "draw/draw & 5+": {
    pt: "empate/empate e +5",
    en: "draw/draw & 5+",
    es: "empate/empate & 5+"
  },
  "draw/{$competitor2} & 5+": {
    pt: "empate/{$competitor2} e 5+",
    en: "draw/{$competitor2} & 5+",
    es: "empate/{$competitor2} & 5+"
  },
  "{$competitor2}/draw & 5+": {
    pt: "{$competitor2}/empate e 5+",
    en: "{$competitor2}/draw & 5+",
    es: "{$competitor2}/empate & 5+"
  },
  sell: { pt: "vender", en: "sell", es: "vender" },
  buy: { pt: "comprar", en: "buy", es: "comprar" },
  mid: { pt: "manter", en: "mid", es: "medio" },
  "{%player} & draw": {
    pt: "{%player} & empate",
    en: "{%player} & draw",
    es: "{%player} & empate"
  },
  "other {$competitor1} win": {
    pt: "outro {$competitor1} vitória",
    en: "other {$competitor1} win",
    es: "otro {$competitor1} gana"
  },
  "other {$competitor2} win": {
    pt: "outro {$competitor2} vitória",
    en: "other {$competitor2} win",
    es: "otro {$competitor2} gana"
  },
  shot: { pt: "remate", en: "shot", es: "disparo" },
  header: { pt: "cabeceamento", en: "header", es: "cabeza" },
  penalty: { pt: "grande penalidade", en: "penalty", es: "penal" },
  "free kick": { pt: "pontapé livre", en: "free kick", es: "falta" },
  "{$competitor1} no goal": {
    pt: "{$competitor1} sem golo",
    en: "{$competitor1} no goal",
    es: "{$competitor1} sin gol"
  },
  "{$competitor2} no goal": {
    pt: "{$competitor2} sem golo",
    en: "{$competitor2} no goal",
    es: "{$competitor2} sin gol"
  },
  "field goal": { pt: "field goal", en: "field goal", es: "gol de campo" },
  safety: { pt: "safety", en: "safety", es: "safety" },
  "{$competitor1} d/st player": {
    pt: "{$competitor1} d/st jogador",
    en: "{$competitor1} d/st player",
    es: "{$competitor1} d/er jugador"
  },
  "{$competitor1} other player": {
    pt: "{$competitor1} outro jogador",
    en: "{$competitor1} other player",
    es: "{$competitor1} otro jugador"
  },
  "{$competitor2} d/st player": {
    pt: "{$competitor2} d/st jogador",
    en: "{$competitor2} d/st player",
    es: "{$competitor2} d/er jugador"
  },
  "{$competitor2} other player": {
    pt: "{$competitor2} outro jogador",
    en: "{$competitor2} other player",
    es: "{$competitor2} otro jugador"
  },
  "field goal attempt": {
    pt: "tentativa de field goal",
    en: "field goal attempt",
    es: "intento de gol de campo"
  },
  "offensive touchdown": {
    pt: "touchdown ofensivo",
    en: "offensive touchdown",
    es: "touchdown ofensivo"
  },
  punt: { pt: "punt", en: "punt", es: "punt" },
  turnover: { pt: "turnover", en: "turnover", es: "pérdida de balón" },
  strike: { pt: "strike", en: "strike", es: "strike" },
  ball: { pt: "bola", en: "ball", es: "bola" },
  hit: { pt: "pancada", en: "hit", es: "hit" },
  single: { pt: "único", en: "single", es: "sencillo" },
  double: { pt: "duplo", en: "double", es: "doble" },
  triple: { pt: "triplo", en: "triple", es: "triple" },
  "home run": { pt: "home run", en: "home run", es: "home run" },
  "no further hit": {
    pt: "sem pancada",
    en: "no further hit",
    es: "no más hits"
  },
  "on base": { pt: "na base", en: "on base", es: "en base" },
  out: { pt: "fora", en: "out", es: "out" },
  rush: { pt: "rush", en: "rush", es: "rush" },
  pass: { pt: "pass", en: "pass", es: "pass" },
  "{$competitor1} 1 point score": {
    pt: "{$competitor1} marcação de 1 ponto",
    en: "{$competitor1} 1 point score",
    es: "{$competitor1} 1 punto"
  },
  "{$competitor1} 2 point score": {
    pt: "{$competitor1} marcação de 2 pontos",
    en: "{$competitor1} 2 point score",
    es: "{$competitor1} 2 punto"
  },
  "{$competitor1} 3 point score": {
    pt: "{$competitor1} marcação de 3 pontos",
    en: "{$competitor1} 3 point score",
    es: "{$competitor1} 3 punto"
  },
  "{$competitor2} 1 point score": {
    pt: "{$competitor2} marcação de 1 pontos",
    en: "{$competitor2} 1 point score",
    es: "{$competitor2} 1 punto"
  },
  "{$competitor2} 2 point score": {
    pt: "{$competitor2} marcação de 2 pontos",
    en: "{$competitor2} 2 point score",
    es: "{$competitor2} 2 punto"
  },
  "{$competitor2} 3 point score": {
    pt: "{$competitor2} marcação de 3 pontos",
    en: "{$competitor2} 3 point score",
    es: "{$competitor2} 3 punto"
  },
  "1 point score": {
    pt: "marcação de 1 ponto",
    en: "1 point score",
    es: "1 punto"
  },
  "2 point score": {
    pt: "marcação de 2 pontos",
    en: "2 point score",
    es: "2 punto"
  },
  "3 point score": {
    pt: "marcação de 3 pontos",
    en: "3 point score",
    es: "3 punto"
  },
  "{$competitor1} ({+hcp}) &amp; over {total}": {
    pt: "{$competitor1} ({+hcp}) &amp; over {total}",
    en: "{$competitor1} ({+hcp}) &amp; over {total}",
    es: "{$competitor1} ({+hcp}) &amp; mas de {total}"
  },
  "{$competitor1} ({+hcp}) &amp; under {total}": {
    pt: "{$competitor1} ({+hcp}) &amp; under {total}",
    en: "{$competitor1} ({+hcp}) &amp; under {total}",
    es: "{$competitor1} ({+hcp}) &amp; menos de {total}"
  },
  "{$competitor2} ({-hcp}) &amp; over {total}": {
    pt: "{$competitor2} ({-hcp}) &amp; over {total}",
    en: "{$competitor2} ({-hcp}) &amp; over {total}",
    es: "{$competitor2} ({-hcp}) &amp; mas de {total}"
  },
  "{{$competitor2} ({-hcp}) &amp; under {total}": {
    pt: "{{$competitor2} ({-hcp}) &amp; under {total}",
    en: "{{$competitor2} ({-hcp}) &amp; under {total}",
    es: "{{$competitor2} ({-hcp}) &amp; menos de {total}"
  },
  "{$competitor2} ({-hcp}) &amp; under {total}": {
    pt: "{$competitor2} ({-hcp}) &amp; under {total}",
    en: "{$competitor2} ({-hcp}) &amp; under {total}",
    es: "{$competitor2} ({-hcp}) &amp; menos de {total}"
  },
  "{$competitor1}": {
    pt: "{$competitor1}",
    en: "{$competitor1}",
    es: "{$competitor1}"
  },
  "{$competitor2}": {
    pt: "{$competitor2}",
    en: "{$competitor2}",
    es: "{$competitor2}"
  },
  "{$competitor1} &amp; 1": {
    pt: "{$competitor1} &amp; 1",
    en: "{$competitor1} &amp; 1",
    es: "{$competitor1} y 1"
  },
  "{$competitor1} &amp; 2": {
    pt: "{$competitor1} &amp; 2",
    en: "{$competitor1} &amp; 2",
    es: "{$competitor1} y 2"
  },
  "{$competitor1} &amp; 3": {
    pt: "{$competitor1} &amp; 3",
    en: "{$competitor1} &amp; 3",
    es: "{$competitor1} y 3"
  },
  "{$competitor1} &amp; decision": {
    pt: "{$competitor1} &amp; decision",
    en: "{$competitor1} &amp; decision",
    es: "{$competitor1} y decision"
  },
  "{$competitor2} &amp; 1": {
    pt: "{$competitor2} &amp; 1",
    en: "{$competitor2} &amp; 1",
    es: "{$competitor2} y 1"
  },
  "{$competitor2} &amp; 2": {
    pt: "{$competitor2} &amp; 2",
    en: "{$competitor2} &amp; 2",
    es: "{$competitor2} y 2"
  },
  "{$competitor2} &amp; 3": {
    pt: "{$competitor2} &amp; 3",
    en: "{$competitor2} &amp; 3",
    es: "{$competitor2} y 3"
  },
  "{$competitor2} &amp; decision": {
    pt: "{$competitor2} &amp; decision",
    en: "{$competitor2} &amp; decision",
    es: "{$competitor2} y decision"
  },
  "{$competitor1} &amp; 4": {
    pt: "{$competitor1} &amp; 4",
    en: "{$competitor1} &amp; 4",
    es: "{$competitor1} y 4"
  },
  "{$competitor1} &amp; 5": {
    pt: "{$competitor1} &amp; 5",
    en: "{$competitor1} &amp; 5",
    es: "{$competitor1} y 5"
  },
  "{$competitor2} &amp; 4": {
    pt: "{$competitor2} &amp; 4",
    en: "{$competitor2} &amp; 4",
    es: "{$competitor2} y 4"
  },
  "{$competitor2} &amp; 5": {
    pt: "{$competitor2} &amp; 5",
    en: "{$competitor2} &amp; 5",
    es: "{$competitor2} y 5"
  },
  "{$competitor1} &amp; 1-3": {
    pt: "{$competitor1} &amp; 1-3",
    en: "{$competitor1} &amp; 1-3",
    es: "{$competitor1} y 1-3"
  },
  "{$competitor1} &amp; 4-6": {
    pt: "{$competitor1} &amp; 4-6",
    en: "{$competitor1} &amp; 4-6",
    es: "{$competitor1} y 4-6"
  },
  "{$competitor1} &amp; 7-9": {
    pt: "{$competitor1} &amp; 7-9",
    en: "{$competitor1} &amp; 7-9",
    es: "{$competitor1} y 7-9"
  },
  "{$competitor1} &amp; 10-12": {
    pt: "{$competitor1} &amp; 10-12",
    en: "{$competitor1} &amp; 10-12",
    es: "{$competitor1} y 10-12"
  },
  "{$competitor2} &amp; 1-3": {
    pt: "{$competitor2} &amp; 1-3",
    en: "{$competitor2} &amp; 1-3",
    es: "{$competitor2} y 1-3"
  },
  "{$competitor2} &amp; 4-6": {
    pt: "{$competitor2} &amp; 4-6",
    en: "{$competitor2} &amp; 4-6",
    es: "{$competitor2} y 4-6"
  },
  "{$competitor2} &amp; 7-9": {
    pt: "{$competitor2} &amp; 7-9",
    en: "{$competitor2} &amp; 7-9",
    es: "{$competitor2} y 7-9"
  },
  "{$competitor2} &amp; 10-12": {
    pt: "{$competitor2} &amp; 10-12",
    en: "{$competitor2} &amp; 10-12",
    es: "{$competitor2} y 10-12"
  },
  "{$competitor1} &amp; 6": {
    pt: "{$competitor1} &amp; 6",
    en: "{$competitor1} &amp; 6",
    es: "{$competitor1} y 6"
  },
  "{$competitor1} &amp; 7": {
    pt: "{$competitor1} &amp; 7",
    en: "{$competitor1} &amp; 7",
    es: "{$competitor1} y 7"
  },
  "{$competitor1} &amp; 8": {
    pt: "{$competitor1} &amp; 8",
    en: "{$competitor1} &amp; 8",
    es: "{$competitor1} y 8"
  },
  "{$competitor1} &amp; 9": {
    pt: "{$competitor1} &amp; 9",
    en: "{$competitor1} &amp; 9",
    es: "{$competitor1} y 9"
  },
  "{$competitor1} &amp; 10": {
    pt: "{$competitor1} &amp; 10",
    en: "{$competitor1} &amp; 10",
    es: "{$competitor1} y 10"
  },
  "{$competitor1} &amp; 11": {
    pt: "{$competitor1} &amp; 11",
    en: "{$competitor1} &amp; 11",
    es: "{$competitor1} y 11"
  },
  "{$competitor1} &amp; 12": {
    pt: "{$competitor1} &amp; 12",
    en: "{$competitor1} &amp; 12",
    es: "{$competitor1} y 12"
  },
  "{$competitor2} &amp; 6": {
    pt: "{$competitor2} &amp; 6",
    en: "{$competitor2} &amp; 6",
    es: "{$competitor2} y 6"
  },
  "{$competitor2} &amp; 7": {
    pt: "{$competitor2} &amp; 7",
    en: "{$competitor2} &amp; 7",
    es: "{$competitor2} y 7"
  },
  "{$competitor2} &amp; 8": {
    pt: "{$competitor2} &amp; 8",
    en: "{$competitor2} &amp; 8",
    es: "{$competitor2} y 8"
  },
  "{$competitor2} &amp; 9": {
    pt: "{$competitor2} &amp; 9",
    en: "{$competitor2} &amp; 9",
    es: "{$competitor2} y 9"
  },
  "{$competitor2} &amp; 10": {
    pt: "{$competitor2} &amp; 10",
    en: "{$competitor2} &amp; 10",
    es: "{$competitor2} y 10"
  },
  "{$competitor2} &amp; 11": {
    pt: "{$competitor2} &amp; 11",
    en: "{$competitor2} &amp; 11",
    es: "{$competitor2} y 11"
  },
  "{$competitor2} &amp; 12": {
    pt: "{$competitor2} &amp; 12",
    en: "{$competitor2} &amp; 12",
    es: "{$competitor2} y 12"
  },
  "{$competitor1} & {$competitor1}": {
    pt: "{$competitor1} e {$competitor1}",
    en: "{$competitor1} & {$competitor1}",
    es: "{$competitor1} & {$competitor1}"
  },
  "{$competitor2} & {$competitor1}": {
    pt: "{$competitor2} e {$competitor1}",
    en: "{$competitor2} & {$competitor1}",
    es: "{$competitor2} & {$competitor1}"
  },
  "{$competitor1} & {$competitor2}": {
    pt: "{$competitor1} e {$competitor2}",
    en: "{$competitor1} & {$competitor2}",
    es: "{$competitor1} & {$competitor2}"
  },
  "{$competitor2} & {$competitor2}": {
    pt: "{$competitor2} e {$competitor2}",
    en: "{$competitor2} & {$competitor2}",
    es: "{$competitor2} & {$competitor2}"
  },
  "{%player1} ({+hcp})": {
    pt: "{%player1} ({+hcp})",
    en: "{%player1} ({+hcp})",
    es: "{%player1} ({+hcp})"
  },
  "{%player2} ({-hcp})": {
    pt: "{%player2} ({-hcp})",
    en: "{%player2} ({-hcp})",
    es: "{%player2} ({-hcp})"
  },
  "{%player1}": { pt: "{%player1}", en: "{%player1}", es: "{%player1}" },
  "{%player2}": { pt: "{%player2}", en: "{%player2}", es: "{%player1}" },
  "00:00 - {(minute-1)}:59": {
    pt: "00:00 - {(minute-1)}:59",
    en: "00:00 - {(minute-1)}:59",
    es: "00:00 - {(minute-1)}:59"
  },
  "{minute}:00+": {
    pt: "{minute}:00+",
    en: "{minute}:00+",
    es: "{minute}:00+"
  },
  "{$competitor1}/{$competitor1} & 1": {
    pt: "{$competitor1}/{$competitor1} e 1",
    en: "{$competitor1}/{$competitor1} & 1",
    es: "{$competitor1}/{$competitor1} & 1"
  },
  "{$competitor2}/{$competitor2} & 1": {
    pt: "{$competitor2}/{$competitor2} e 1",
    en: "{$competitor2}/{$competitor2} & 1",
    es: "{$competitor2}/{$competitor2} & 1"
  },
  "{$competitor1}/{$competitor1} & 2": {
    pt: "{$competitor1}/{$competitor1} e 2",
    en: "{$competitor1}/{$competitor1} & 2",
    es: "{$competitor1}/{$competitor1} & 2"
  },
  "{$competitor2}/{$competitor2} & 2": {
    pt: "{$competitor2}/{$competitor2} e 2",
    en: "{$competitor2}/{$competitor2} & 2",
    es: "{$competitor2}/{$competitor2} & 2"
  },
  "{$competitor1}/{$competitor1} & 3": {
    pt: "{$competitor1}/{$competitor1} e 3",
    en: "{$competitor1}/{$competitor1} & 3",
    es: "{$competitor1}/{$competitor1} & 3"
  },
  "{$competitor1}/{$competitor2} & 3": {
    pt: "{$competitor1}/{$competitor2} e 3",
    en: "{$competitor1}/{$competitor2} & 3",
    es: "{$competitor1}/{$competitor2} & 3"
  },
  "{$competitor2}/{$competitor1} & 3": {
    pt: "{$competitor2}/{$competitor1} e 3",
    en: "{$competitor2}/{$competitor1} & 3",
    es: "{$competitor2}/{$competitor1} & 3"
  },
  "{$competitor2}/{$competitor2} & 3": {
    pt: "{$competitor2}/{$competitor2} e 3",
    en: "{$competitor2}/{$competitor2} & 3",
    es: "{$competitor2}/{$competitor2} & 3"
  },
  "{$competitor1}/{$competitor1} & 4": {
    pt: "{$competitor1}/{$competitor1} e 4",
    en: "{$competitor1}/{$competitor1} & 4",
    es: "{$competitor1}/{$competitor1} & 4"
  },
  "{$competitor1}/{$competitor2} & 4": {
    pt: "{$competitor1}/{$competitor2} e 4",
    en: "{$competitor1}/{$competitor2} & 4",
    es: "{$competitor1}/{$competitor2} & 4"
  },
  "{$competitor2}/{$competitor1} & 4": {
    pt: "{$competitor2}/{$competitor1} e 4",
    en: "{$competitor2}/{$competitor1} & 4",
    es: "{$competitor2}/{$competitor1} & 4"
  },
  "{$competitor2}/{$competitor2} & 4": {
    pt: "{$competitor2}/{$competitor2} e 4",
    en: "{$competitor2}/{$competitor2} & 4",
    es: "{$competitor2}/{$competitor2} & 4"
  },
  "{$competitor1}/{$competitor1} & 5+": {
    pt: "{$competitor1}/{$competitor1} e 5+",
    en: "{$competitor1}/{$competitor1} & 5+",
    es: "{$competitor1}/{$competitor1} & 5+"
  },
  "{$competitor1}/{$competitor2} & 5+": {
    pt: "{$competitor1}/{$competitor2} e 5+",
    en: "{$competitor1}/{$competitor2} & 5+",
    es: "{$competitor1}/{$competitor2} & 5+"
  },
  "{$competitor2}/{$competitor1} & 5+": {
    pt: "{$competitor2}/{$competitor1} e 5+",
    en: "{$competitor2}/{$competitor1} & 5+",
    es: "{$competitor2}/{$competitor1} & 5+"
  },
  "{$competitor2}/{$competitor2} & 5+": {
    pt: "{$competitor2}/{$competitor2} e 5+",
    en: "{$competitor2}/{$competitor2} & 5+",
    es: "{$competitor2}/{$competitor2} & 5+"
  },
  "{%player} & {$competitor1}": {
    pt: "{%player} & {$competitor1}",
    en: "{%player} & {$competitor1}",
    es: "{%player} & {$competitor1}"
  },
  "{%player} & {$competitor2}": {
    pt: "{%player} & {$competitor2}",
    en: "{%player} & {$competitor2}",
    es: "{%player} & {$competitor2}"
  },
  "{%player} & 1:0": {
    pt: "{%player} & 1:0",
    en: "{%player} & 1:0",
    es: "{%player} & 1:0"
  },
  "{%player} & 2:0": {
    pt: "{%player} & 2:0",
    en: "{%player} & 2:0",
    es: "{%player} & 2:0"
  },
  "{%player} & 3:0": {
    pt: "{%player} & 3:0",
    en: "{%player} & 3:0",
    es: "{%player} & 3:0"
  },
  "{%player} & 4:0": {
    pt: "{%player} & 4:0",
    en: "{%player} & 4:0",
    es: "{%player} & 4:0"
  },
  "{%player} & 2:1": {
    pt: "{%player} & 2:1",
    en: "{%player} & 2:1",
    es: "{%player} & 2:1"
  },
  "{%player} & 3:1": {
    pt: "{%player} & 3:1",
    en: "{%player} & 3:1",
    es: "{%player} & 3:1"
  },
  "{%player} & 4:1": {
    pt: "{%player} & 4:1",
    en: "{%player} & 4:1",
    es: "{%player} & 4:1"
  },
  "{%player} & 3:2": {
    pt: "{%player} & 3:2",
    en: "{%player} & 3:2",
    es: "{%player} & 3:2"
  },
  "{%player} & 4:2": {
    pt: "{%player} & 4:2",
    en: "{%player} & 4:2",
    es: "{%player} & 4:2"
  },
  "{%player} & 4:3": {
    pt: "{%player} & 4:3",
    en: "{%player} & 4:3",
    es: "{%player} & 4:3"
  },
  "{%player} & 0:1": {
    pt: "{%player} & 0:1",
    en: "{%player} & 0:1",
    es: "{%player} & 0:1"
  },
  "{%player} & 0:2": {
    pt: "{%player} & 0:2",
    en: "{%player} & 0:2",
    es: "{%player} & 0:2"
  },
  "{%player} & 0:3": {
    pt: "{%player} & 0:3",
    en: "{%player} & 0:3",
    es: "{%player} & 0:3"
  },
  "{%player} & 0:4": {
    pt: "{%player} & 0:4",
    en: "{%player} & 0:4",
    es: "{%player} & 0:4"
  },
  "{%player} & 1:2": {
    pt: "{%player} & 1:2",
    en: "{%player} & 1:2",
    es: "{%player} & 1:2"
  },
  "{%player} & 1:3": {
    pt: "{%player} & 1:3",
    en: "{%player} & 1:3",
    es: "{%player} & 1:3"
  },
  "{%player} & 1:4": {
    pt: "{%player} & 1:4",
    en: "{%player} & 1:4",
    es: "{%player} & 1:4"
  },
  "{%player} & 2:3": {
    pt: "{%player} & 2:3",
    en: "{%player} & 2:3",
    es: "{%player} & 2:3"
  },
  "{%player} & 2:4": {
    pt: "{%player} & 2:4",
    en: "{%player} & 2:4",
    es: "{%player} & 2:4"
  },
  "{%player} & 3:4": {
    pt: "{%player} & 3:4",
    en: "{%player} & 3:4",
    es: "{%player} & 3:4"
  },
  "{%player} & 1:1": {
    pt: "{%player} & 1:1",
    en: "{%player} & 1:1",
    es: "{%player} & 1:1"
  },
  "{%player} & 2:2": {
    pt: "{%player} & 2:2",
    en: "{%player} & 2:2",
    es: "{%player} & 2:2"
  },
  "{%player} & 3:3": {
    pt: "{%player} & 3:3",
    en: "{%player} & 3:3",
    es: "{%player} & 3:3"
  },
  "{%player} & 4:4": {
    pt: "{%player} & 4:4",
    en: "{%player} & 4:4",
    es: "{%player} & 4:4"
  },
  "1x": { pt: "1x", en: "1x", es: "1x" },
  x2: { pt: "x2", en: "x2", es: "x2" },

  ///////////////////////////////////live translation//////////////////////////////////////////////////

  exactly: { pt: "exatamente", en: "exactly", es: "exacto" },
  "away win by 6+": {
    pt: "vitória do time visitante por 6+",
    en: "away win by 6+",
    es: "visitante gana por 6+"
  },
  "home win by 6+": {
    pt: "vitória da equipe da casa por 6+",
    en: "home win by 6+",
    es: "local gana por 6+"
  },
  "away win by 3+": {
    pt: "vitória da equipe visitante por 3+",
    en: "away win by 3+",
    es: "visitante gana por 3+"
  },
  "home win by 3+": {
    pt: "time da casa vence por 3+",
    en: "home win by 3+",
    es: "local gana por 3+"
  },
  tie: { pt: "empate", en: "tie", es: "empate" },
  goal: { pt: "golo", en: "goal", es: "gol" },
  nogoal: { pt: "sem golo", en: "nogoal", es: "no gol" },
  "player 1 to 0": {
    pt: "jogador 1 a 0",
    en: "player 1 to 0",
    es: "jugador 1 a 0"
  },
  "player 1 to 15": {
    pt: "jogador 1 a 15",
    en: "player 1 to 15",
    es: "jugador 1 a 15"
  },
  "player 1 to 30": {
    pt: "jogador 1 a 30",
    en: "player 1 to 30",
    es: "jugador 1 a 30"
  },
  "player 1 to 40": {
    pt: "jogador 1 a 40",
    en: "player 1 to 40",
    es: "jugador 1 a 40"
  },
  "player 2 to 0": {
    pt: "jogador 2 a 0",
    en: "player 2 to 0",
    es: "jugador 2 a 0"
  },
  "player 2 to 15": {
    pt: "jogador 2 a 15",
    en: "player 2 to 15",
    es: "jugador 2 a 15"
  },
  "player 2 to 30": {
    pt: "jogador 2 a 30",
    en: "player 2 to 30",
    es: "jugador 2 a 30"
  },
  "player 2 to 40": {
    pt: "jogador 2 a 40",
    en: "player 2 to 40",
    es: "jugador 2 a 40"
  },
  "overtime first half correct score flex": {
    pt: "resultado correto da primeira parte do prolongamento flex",
    en: "overtime first half correct score flex",
    es: "marcador exacto flex 1ª parte prórroga"
  },
  equals: { pt: "iguais", en: "equals", es: "iguales" },
  "first half": {
    pt: "primeira parte",
    en: "first half",
    es: "primera mitad"
  },
  "second half": {
    pt: "segunda parte",
    en: "second half",
    es: "segunda mitad"
  },
  "away and over": {
    pt: "visitante e mais de",
    en: "away and over",
    es: "visitante y mas de "
  },
  "away and under": {
    pt: "visitante e menos de",
    en: "away and under",
    es: "visitante y menos de"
  },
  "draw and over": {
    pt: "empate e mais de",
    en: "draw and over",
    es: "empate y mas de"
  },
  "draw and under": {
    pt: "empate e menos de",
    en: "draw and under",
    es: "empate y menos de"
  },
  "home and over": {
    pt: "equipe local e mais",
    en: "home and over",
    es: "local y mas de"
  },
  "home and under": {
    pt: "equipe local e menos de",
    en: "home and under",
    es: "local y menos de"
  },
  "away ot": {
    pt: "visitante horas extras",
    en: "away ot",
    es: "visitante ot"
  },
  "away penalties": {
    pt: "visitante penalidades",
    en: "away penalties",
    es: "visitante penales"
  },
  "away regular time": {
    pt: "visitante tempo regular",
    en: "away regular time",
    es: "visitante en tiempo regular"
  },
  "home ot": {
    pt: "equipe local tempo extra",
    en: "home ot",
    es: "local ot"
  },
  "home penalties": {
    pt: "equipe local penalidades",
    en: "home penalties",
    es: "local penales"
  },

  "home regular time": {
    pt: "equipe local tempo regular",
    en: "home regular time",
    es: "local tiempo regular"
  },
  aa: { pt: "aa", en: "aa", es: "aa" },
  ad: { pt: "ad", en: "ad", es: "ad" },
  ah: { pt: "ah", en: "ah", es: "ah" },
  da: { pt: "da", en: "da", es: "da" },
  dd: { pt: "dd", en: "dd", es: "dd" },
  dh: { pt: "dh", en: "dh", es: "dh" },
  ha: { pt: "ha", en: "ha", es: "ha" },
  hd: { pt: "hd", en: "hd", es: "hd" },
  hh: { pt: "hh", en: "hh", es: "hh" },
  "away and no": {
    pt: "visitante e não",
    en: "away and no",
    es: "visitante y no"
  },
  "away and yes": {
    pt: "visitante e sim",
    en: "away and yes",
    es: "visitante y sí"
  },
  "draw and no": {
    pt: "empate e não",
    en: "draw and no",
    es: "empate y no"
  },
  "draw and yes": {
    pt: "empate e sim",
    en: "draw and yes",
    es: "empate y sí"
  },
  "home and no": { pt: "local e não", en: "home and no", es: "local y no" },
  "home and yes": {
    pt: "local e sim",
    en: "home and yes",
    es: "local y sí"
  },
  "1 by any other score": {
    pt: "1 por qualquer outro resultado",
    en: "1 by any other score",
    es: "1 por cualquier otro resultado"
  },
  "2 by any other score": {
    pt: "2 por qualquer outro resultado",
    en: "2 by any other score",
    es: "2 por cualquier otro resultado"
  },
  away: { pt: "equipe visitante", en: "away", es: "visitante " },
  home: { pt: "equipe local", en: "home", es: "local" },
  "12 and over": { es: "12 o mas", en: "12 and over" },
  "12 and under": { es: "12 o menos", en: "12 and under" },
  "1x and over": { es: "1x y mas", en: "1x and over" },
  "1x and under": { es: "1x y menos", en: "1x and under" },
  "x2 and over": { es: "x2 y mas", en: "x2 and over" },
  "x2 and under": { es: "x2 y menos", en: "x2 and under" },
  "away 1-3": { pt: "visitante 1-3", en: "away 1-3", es: "visitante 1-3" },
  "away 10-12": {
    pt: "visitante 10-12",
    en: "away 10-12",
    es: "visitante 10-12"
  },
  "away 13-15": {
    pt: "visitante 13-15",
    en: "away 13-15",
    es: "visitante 13-15"
  },
  "away 16+": { pt: "visitante 16+", en: "away 16+", es: "visitante +16" },
  "away 4-6": { pt: "visitante 4-6", en: "away 4-6", es: "visitante 4-6" },
  "away 7-9": { pt: "visitante 7-9", en: "away 7-9", es: "visitante 7-9" },
  "home 1-3": { pt: "equipe local 1-3", en: "home 1-3", es: "local 1-3" },
  "home 10-12": {
    pt: "equipe local 10-12",
    en: "home 10-12",
    es: "local 10-12"
  },
  "home 13-15": {
    pt: "equipe local 13-15",
    en: "home 13-15",
    es: "local 13-15"
  },
  "home 16+": { pt: "equipe local 16+", en: "home 16+", es: "local 16+" },
  "home 4-6": { pt: "equipe local 4-6", en: "home 4-6", es: "local 4-6" },
  "home 7-9": { pt: "equipe local 7-9", en: "home 7-9", es: "local 7-9" },
  "away 1-2": { pt: "visitante 1-2", en: "away 1-2", es: "visitante 1-2" },
  "away 11+": { pt: "visitante 11+", en: "away 11+", es: "visitante 11+" },
  "away 3-4": { pt: "visitante 3-4", en: "away 3-4", es: "visitante 3-4" },
  "away 5-6": { pt: "visitante 5-6", en: "away 5-6", es: "visitante 5-6" },
  "away 7-8": { pt: "visitante 7-8", en: "away 7-8", es: "visitante 7-8" },
  "away 9-10": {
    pt: "visitante 9-10",
    en: "away 9-10",
    es: "visitante 9-10"
  },
  "home 1-2": { pt: "equipe local 1-2", en: "home 1-2", es: "local 1-2" },
  "home 11+": { pt: "equipe local 11+", en: "home 11+", es: "local 11+" },
  "home 3-4": { pt: "equipe local 3-4", en: "home 3-4", es: "local 3-4" },
  "home 5-6": { pt: "equipe local 5-6", en: "home 5-6", es: "local 5-6" },
  "home 7-8": { pt: "equipe local 7-8", en: "home 7-8", es: "local 7-8" },
  "home 9-10": {
    pt: "equipe local 9-10",
    en: "home 9-10",
    es: "local 9-10"
  },
  "away 10-13": {
    pt: "visitante 10-13",
    en: "away 10-13",
    es: "visitante 10-13"
  },
  "away 14-16": {
    pt: "visitante 14-16",
    en: "away 14-16",
    es: "visitante 14-16"
  },
  "away 17-20": {
    pt: "visitante 17-20",
    en: "away 17-20",
    es: "visitante 17-20"
  },
  "away 21+": { pt: "visitante 21+", en: "away 21+", es: "visitante 21+" },
  "away 3-6": { pt: "visitante 3-6", en: "away 3-6", es: "visitante 3-6" },
  "home 10-13": {
    pt: "equipe local 10-13",
    en: "home 10-13",
    es: "local 10-13"
  },
  "home 14-16": {
    pt: "equipe local 14-16",
    en: "home 14-16",
    es: "local 14-16"
  },
  "home 17-20": {
    pt: "equipe local 17-20",
    en: "home 17-20",
    es: "local 17-20"
  },
  "home 21+": { pt: "equipe local 21+", en: "home 21+", es: "local 21+" },
  "home 3-6": { pt: "equipe local 3-6", en: "home 3-6", es: "local 3-6" },
  "away 12+": { pt: "visitante 12+", en: "away 12+", es: "visitante 12+" },
  "away 2": { pt: "visitante 2", en: "away 2", es: "visitante 2" },
  "away 5-7": { pt: "visitante 5-7", en: "away 5-7", es: "visitante 5-7" },
  "away 8-11": {
    pt: "visitante 8-11",
    en: "away 8-11",
    es: "visitante 8-11"
  },
  "home 12+": { pt: "equipe local 12+", en: "home 12+", es: "local 12+" },
  "home 2": { pt: "equipe local 2", en: "home 2", es: "local 2" },
  "home 5-7": { pt: "equipe local 5-7", en: "home 5-7", es: "local 5-7" },
  "home 8-11": {
    pt: "equipe local 8-11",
    en: "home 8-11",
    es: "local 8-11"
  },
  "11:21 or better": {
    pt: "11:21 ou melhor",
    en: "11:21 or better",
    es: "11:21 o mejor"
  },
  "15:25 or better": {
    pt: "15:25 ou melhor",
    en: "15:25 or better",
    es: "15:25 o mejor"
  },
  "21:11 or better": {
    pt: "21:11 ou melhor",
    en: "21:11 or better",
    es: "21:11 o mejor"
  },
  "25:15 or better": {
    pt: "25:15 ou melhor",
    en: "25:15 or better",
    es: "25:15 o mejor"
  },
  "away after extra points": {
    pt: "time visitante depois de pontos extras",
    en: "away after extra points",
    es: "visitante despues de puntos extra"
  },
  "home after extra points": {
    pt: "equipe local after extra points",
    en: "home after extra points",
    es: "local despues de puntos extra"
  },
  "15:5 or better": {
    pt: "15:5 ou melhor",
    en: "15:5 or better",
    es: "15:5 o mejor"
  },
  "5:15 or better": {
    pt: "5:15 ou melhor",
    en: "5:15 or better",
    es: "5:15 o mejor"
  },
  "4 points": { pt: "4 pontos", en: "4 points", es: "4 puntos" },
  "5 points": { pt: "5 pontos", en: "5 points", es: "5 puntos" },
  "6 points": { pt: "6 pontos", en: "6 points", es: "6 puntos" },
  "over 6 points": {
    pt: "mais de 6 pontos",
    en: "over 6 points",
    es: "mas de 6 puntos"
  },
  "player 1 win to love": {
    pt: "jogador 1 ganhar para amar",
    en: "player 1 win to love",
    es: "jugador 1 gana con amor"
  },
  "player 2 win to love": {
    pt: "jogador 2: ganhe para amar",
    en: "player 2 win to love",
    es: "jugador 2 gana con amor"
  },
  "away no": { pt: "visitante não", en: "away no", es: "visitante no" },
  "away yes": { pt: "visitante sim", en: "away yes", es: "visitante si" },
  "home no": { pt: "equipe local nao", en: "home no", es: "local no" },
  "home yes": { pt: "local sim", en: "home yes", es: "local si" },
  overtime: { pt: "tempo extra", en: "overtime", es: "tiempo extra" },
  regulation: { pt: "regulamento", en: "regulation", es: "regulado" },
  shootout: { pt: "disparos", en: "shootout", es: "shootout" },
  "away 1": { pt: "visitante 1", en: "away 1", es: "visitante 1" },
  "away 3": { pt: "visitante 3", en: "away 3", es: "visitante 3" },
  "away 4": { pt: "visitante 4", en: "away 4", es: "visitante 4" },
  "away 5+": { pt: "visitante 5+", en: "away 5+", es: "visitante 5+" },
  "home 1": { pt: "equipe local 1", en: "home 1", es: "local 1" },
  "home 3": { pt: "equipe local 3", en: "home 3", es: "local 3" },
  "home 4": { pt: "equipe local 4", en: "home 4", es: "local 4" },
  "home 5+": { pt: "equipe local 5+", en: "home 5+", es: "local 5+" },
  "1 no": { pt: "1 não", en: "1 no", es: "1 no" },
  "1 yes": { pt: "1 sim", en: "1 yes", es: "1 si" },
  " 2 no": { pt: " 2 não", en: " 2 no", es: " 2 no" },
  " 2 yes": { pt: " 2 sim", en: " 2 yes", es: " 2 si" },
  "11:3 or better": {
    pt: "11:3 ou melhor",
    en: "11:3 or better",
    es: "11:3 o mejor"
  },
  "3:11 or better": {
    pt: "3:11 ou melhor",
    en: "3:11 or better",
    es: "3:11 o mejor"
  },
  "away 7+": { pt: "visitante 7+", en: "away 7+", es: "visitante 7+" },
  "home 7+": { pt: "equipe local 7+", en: "home 7+", es: "local 7+" },
  "away 13-16": {
    pt: "visitante 13-16",
    en: "away 13-16",
    es: "visitante 13-16"
  },
  "home 13-16": {
    pt: "equipe local 13-16",
    en: "home 13-16",
    es: "local 13-16"
  },
  "away 2+": { pt: "visitante 2+", en: "away 2+", es: "visitante 2+" },
  "home 2+": { pt: "equipe local 2+", en: "home 2+", es: "local 2+" },
  "away 3+": { pt: "visitante 3+", en: "away 3+", es: "visitante 3+" },
  "home 3+": { pt: "equipe local 3+", en: "home 3+", es: "local 3+" },
  "away 1-5": { pt: "visitante 1-5", en: "away 1-5", es: "visitante 1-5" },
  "away 6+": { pt: "visitante 6+", en: "away 6+", es: "visitante 6+" },
  "home 1-5": { pt: "equipe local 1-5", en: "home 1-5", es: "local 1-5" },
  "home 6+": { pt: "equipe local 6+", en: "home 6+", es: "local 6+" },
  "away 3-5": { pt: "visitante 3-5", en: "away 3-5", es: "visitante 3-5" },
  "away 6-8": { pt: "visitante 6-8", en: "away 6-8", es: "visitante 6-8" },
  "away 9+": { pt: "visitante 9+", en: "away 9+", es: "visitante 9+" },
  "home 3-5": { pt: "equipe local 3-5", en: "home 3-5", es: "local 3-5" },
  "home 6-8": { pt: "equipe local 6-8", en: "home 6-8", es: "local 6-8" },
  "home 9+": { pt: "equipe local 9+", en: "home 9+", es: "local 9+" },
  "13:21 or better": {
    pt: "13:21 ou melhor",
    en: "13:21 or better",
    es: "13:21 o mejor"
  },
  "21:13 or better": {
    pt: "21:13 ou melhor",
    en: "21:13 or better",
    es: "21:13 o mejor"
  },
  behind: { pt: "atrás", en: "behind", es: "detras de" },
  "away 1-12": {
    pt: "visitante 1-12",
    en: "away 1-12",
    es: "visitante 1-12"
  },
  "away 13-24": {
    pt: "visitante 13-24",
    en: "away 13-24",
    es: "visitante 13-24"
  },
  "away 25-36": {
    pt: "visitante 25-36",
    en: "away 25-36",
    es: "visitante 25-36"
  },
  "away 37-48": {
    pt: "visitante 37-48",
    en: "away 37-48",
    es: "visitante 37-48"
  },
  "away 49-60": {
    pt: "visitante 49-60",
    en: "away 49-60",
    es: "visitante 49-60"
  },
  "away 61-72": {
    pt: "visitante 61-72",
    en: "away 61-72",
    es: "visitante 61-72"
  },
  "away 73+": { pt: "visitante 73+", en: "away 73+", es: "visitante 73+" },
  "home 1-12": {
    pt: "equipe local 1-12",
    en: "home 1-12",
    es: "local 1-12"
  },
  "home 13-24": {
    pt: "equipe local 13-24",
    en: "home 13-24",
    es: "local 13-24"
  },
  "home 25-36": {
    pt: "equipe local 25-36",
    en: "home 25-36",
    es: "local 25-36"
  },
  "home 37-48": {
    pt: "equipe local 37-48",
    en: "home 37-48",
    es: "local 37-48"
  },
  "home 49-60": {
    pt: "equipe local 49-60",
    en: "home 49-60",
    es: "local 49-60"
  },
  "home 61-72": {
    pt: "equipe local 61-72",
    en: "home 61-72",
    es: "local 61-72"
  },
  "home 73+": { pt: "equipe local 73+", en: "home 73+", es: "local 73+" },
  "home 0-9": { pt: "equipe local 0-9", en: "home 0-9", es: "local 0-9" },
  "home 10-11": {
    pt: "equipe local 10-11",
    en: "home 10-11",
    es: "local 10-11"
  },
  "home 12-13": {
    pt: "equipe local 12-13",
    en: "home 12-13",
    es: "local 12-13"
  },
  "home 14-15": {
    pt: "equipe local 14-15",
    en: "home 14-15",
    es: "local 14-15"
  },
  "home 16-17": {
    pt: "equipe local 16-17",
    en: "home 16-17",
    es: "local 16-17"
  },
  "home 18+": { pt: "equipe local 18+", en: "home 18+", es: "local 18+" },
  "away 1-18": {
    pt: "visitante 1-18",
    en: "away 1-18",
    es: "visitante 1-18"
  },
  "away 19+": { pt: "visitante 19+", en: "away 19+", es: "visitante 19+" },
  "home 1-18": {
    pt: "equipe local 1-18",
    en: "home 1-18",
    es: "local 1-18"
  },
  "home 19+": { pt: "equipe local 19+", en: "home 19+", es: "local 19+" },
  "away 37+": { pt: "visitante 37+", en: "away 37+", es: "visitante 37+" },
  "home 37+": { pt: "equipe local 37+", en: "home 37+", es: "local 37+" },
  "away 1-6": { pt: "visitante 1-6", en: "away 1-6", es: "visitante 1-6" },
  "away 13-18": {
    pt: "visitante 13-18",
    en: "away 13-18",
    es: "visitante 13-18"
  },
  "away 19-24": {
    pt: "visitante 19-24",
    en: "away 19-24",
    es: "visitante 19-24"
  },
  "away 25-30": {
    pt: "visitante 25-30",
    en: "away 25-30",
    es: "visitante 25-30"
  },
  "away 31-36": {
    pt: "visitante 31-36",
    en: "away 31-36",
    es: "visitante 31-36"
  },
  "away 7-12": {
    pt: "visitante 7-12",
    en: "away 7-12",
    es: "visitante 7-12"
  },
  "home 1-6": { pt: "equipe local 1-6", en: "home 1-6", es: "local 1-6" },
  "home 13-18": {
    pt: "equipe local 13-18",
    en: "home 13-18",
    es: "local 13-18"
  },
  "home 19-24": {
    pt: "equipe local 19-24",
    en: "home 19-24",
    es: "local 19-24"
  },
  "home 25-30": {
    pt: "equipe local 25-30",
    en: "home 25-30",
    es: "local 25-30"
  },
  "home 31-36": {
    pt: "equipe local 31-36",
    en: "home 31-36",
    es: "local 31-36"
  },
  "home 7-12": {
    pt: "equipe local 7-12",
    en: "home 7-12",
    es: "local 7-12"
  },
  "away 1-20": {
    pt: "visitante 1-20",
    en: "away 1-20",
    es: "visitante 1-20"
  },
  "home 1-20": {
    pt: "equipe local 1-20",
    en: "home 1-20",
    es: "local 1-20"
  },
  "away 1-24": {
    pt: "visitante 1-24",
    en: "away 1-24",
    es: "visitante 1-24"
  },
  "away 25+": { pt: "visitante 25+", en: "away 25+", es: "visitante 25+" },
  "home 1-24": {
    pt: "equipe local 1-24",
    en: "home 1-24",
    es: "local 1-24"
  },
  "home 25+": { pt: "equipe local 25+", en: "home 25+", es: "local 25+" },
  "away 1-39": {
    pt: "visitante 1-39",
    en: "away 1-39",
    es: "visitante 1-39"
  },
  "away 40+": { pt: "visitante 40+", en: "away 40+", es: "visitante 40+" },
  "home 1-39": {
    pt: "equipe local 1-39",
    en: "home 1-39",
    es: "local 1-39"
  },
  "home 40+": { pt: "equipe local 40+", en: "home 40+", es: "local 40+" },
  "away 4+": { pt: "visitante 4+", en: "away 4+", es: "visitante 4+" },
  "home 4+": { pt: "equipe local 4+", en: "home 4+", es: "local 4+" },
  "away by any other": {
    pt: "equipe visitante por qualquer outro",
    en: "away by any other",
    es: "visitante por cualquier otro"
  },
  "home by any other": {
    pt: "casa por qualquer outro",
    en: "home by any other",
    es: "local por cualquier otro"
  },
  "1 & no": { pt: "1 e não", en: "1 & no", es: "1 & no" },
  "1 & yes": { pt: "1e sim", en: "1 & yes", es: "1 & si" },
  "2 & no": { pt: "2 e não", en: "2 & no", es: "2 & no" },
  "2 & yes": { pt: "2 e sim", en: "2 & yes", es: "2 & si" },
  "any other outcome": {
    pt: "qualquer outro resultado",
    en: "any other outcome",
    es: "cualquier otro resultado"
  },
  miss: { pt: "senhorita", en: "miss", es: "perdida" },
  score: { pt: "pontuação", en: "score", es: "tanteador" },
  "to win to 0, 15 or 30": {
    pt: "para ganhar a 0, 15 ou 30",
    en: "to win to 0, 15 or 30",
    es: "ganar a 0, 15 o 30"
  },
  "to win to 0 or 15": {
    pt: "para ganhar a 0 ou 15",
    en: "to win to 0 or 15",
    es: "ganar a 0, 15 o 30"
  },
  corner: { pt: "cantos", en: "corner", es: "corner" },
  "goal kick": { pt: "chute a gol", en: "goal kick", es: "saque de puerta" },
  "no set piece": {
    pt: "sem peça de fixação",
    en: "no set piece",
    es: "sin pieza fija"
  },
  "penalty awarded": {
    pt: "pênalti concedido",
    en: "penalty awarded",
    es: "penal a favor"
  },
  "throw in": { pt: "jogar para dentro", en: "throw in", es: "lanzar" },
  "away 0-9": { pt: "visitante 0-9", en: "away 0-9", es: "visitante 0-9" },
  "away 10-11": {
    pt: "visitante 10-11",
    en: "away 10-11",
    es: "visitante 10-11"
  },
  "away 12-13": {
    pt: "visitante 12-13",
    en: "away 12-13",
    es: "visitante 12-13"
  },
  "away 14-15": {
    pt: "visitante 14-15",
    en: "away 14-15",
    es: "visitante 14-15"
  },
  "away 16-17": {
    pt: "visitante 16-17",
    en: "away 16-17",
    es: "visitante 16-17"
  },
  "away 18+": { pt: "visitante 18+", en: "away 18+", es: "visitante 18+" },
  "away and over and gg": {
    pt: "visitante e mais de e gg",
    en: "away and over and gg",
    es: "visitante y mas de y gg"
  },
  "away and over and ng": {
    pt: "visitante e mais de e ng",
    en: "away and over and ng",
    es: "visitante y mas de y ng"
  },
  "away and under and gg": {
    pt: "visitante e menos de e gg",
    en: "away and under and gg",
    es: "visitante y menos de y gg"
  },
  "away and under and ng": {
    pt: "visitante e menos de e ng",
    en: "away and under and ng",
    es: "visitante y menos de y ng"
  },
  "draw and over and gg": {
    pt: "empate e mais de e gg",
    en: "draw and over and gg",
    es: "empate y mas de y gg"
  },
  "draw and over and ng": {
    pt: "empate e mais de e ng",
    en: "draw and over and ng",
    es: "empate y mas de y ng"
  },
  "draw and under and gg": {
    pt: "empate e menos de e gg",
    en: "draw and under and gg",
    es: "empate y menos de y gg"
  },
  "draw and under and ng": {
    pt: "empate e menos de e ng",
    en: "draw and under and ng",
    es: "empate y menos de y ng"
  },
  "home and over and gg": {
    pt: "casa e mais e gg",
    en: "home and over and gg",
    es: "local y mas de y gg"
  },
  "home and over and ng": {
    pt: "casa e mais e ng",
    en: "home and over and ng",
    es: "local y mas de y ng"
  },
  "home and under and gg": {
    pt: "casa e menos de e gg",
    en: "home and under and gg",
    es: "local y menos de y gg"
  },
  "home and under and ng": {
    pt: "casa e menos de e ng",
    en: "home and under and ng",
    es: "local y menos de y ng"
  },
  "mais de": { pt: "mais de", en: "mais de" },
  "12 e mais de": { pt: "12 e mais de", en: "12 e mais de" },
  "12 e menos de": { pt: "12 e menos de", en: "12 e menos de" },
  "1x e mais de": { pt: "1x e mais de", en: "1x e mais de" },
  "1x e menos de": { pt: "1x e menos de", en: "1x e menos de" },
  "x2 e mais de": { pt: "x2 e mais de", en: "x2 e mais de" },
  "x2 e menos de": { pt: "x2 e menos de", en: "x2 e menos de" }
};
